import { enviarFormulario, enviarJson, obterJson } from './v2/api';
import { emailNovoValido as _emailNovoValido, ligarCriteriosSenha, nomeLimpo as _nomeLimpo, nomeValido as _nomeValido, senhaValida, sugerirEmail as _sugerirEmail } from './v2/criteriosSenha';
import { avisar, avisarErro, avisarSucesso } from './v2/aviso';
import { ocupado, ocupar } from './v2/botao';
import { formatar, textos, url, urlApi } from './v2/config';
import { iniciarMedicaoPagina, registrarConversaoCadastro, registrarEvento } from './v2/medicao';
import { aoRespostaGoogle, CHAVE_GOOGLE_PENDENTE } from './v2/terceiros';
import { buscarPais as _buscarPais, carregarBibliotecas as _carregarBibliotecas, carregarPaises as _carregarPaises, cidadesDaResposta as _cidadesDaResposta, erroDoFone as _erroDoFoneV2, fone as _fone, indicadorDeCep as _indicadorDeCep,
    ligarFormContato, ligarTelefones as _ligarTelefones, listaDeCidades as _listaDeCidadesV2, listaDeOpcoes as _listaDeOpcoes, MASCARAS, mascarar as _mascarar, mostrarErro,
    nomeDaCidade as _nomeDaCidade, prop as _prop, semAcento as _semAcento, so as _so, telefone as _telefone, validarAoVivo as _validarAoVivo } from './v2/campos';
import { esquecerLogado } from './v2/topo';
import { avisarLogin, obterGeo, obterUsuario } from './v2/usuario';
import { sincronizarSalvas } from './v2/salvas';
import { esquecerAparelho } from './v2/push';

// Login v2 (M5): /login, /candidato/esqueci-senha, /cadastrar-curriculo e /candidato/recuperar-senha/{hash}. Um passo por
// vez, cada um no histórico (o Voltar do celular volta um passo); o cadastro e o currículo completo são passos do mesmo cartão. Os endpoints e as regras são os do v1 (login.js,
// login-esqueci-senha.js, login-nova-senha.js); o que mudou está no plano (§8, M5).
const $ = id => document.getElementById(id);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const semAnimacao = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const T = textos($('entPagina'));
const cartao = $('entCard');
const PENDENCIA = 'candidaturaPendente';
const PENDENCIA_VALIDADE = 24 * 60 * 60 * 1000;

// ---------- comum (login e nova senha) ----------
// Resposta do LoginController: o modelo do login sai em PascalCase e as falhas anônimas em minúsculas.
const _ok = r => !!(r && (r.Sucesso ?? r.sucesso));

// O aviso pelo id (entE-…): o "resumo" e o "contato" são erros sem campo.
function _mostrarErro(id, texto) {
    mostrarErro($(id), texto, $(`entE-${id}`));
}

function _mostrarErros(erros) {
    Object.entries(erros).forEach(([id, texto]) => _mostrarErro(id, texto));
    const primeiro = Object.keys(erros).find(id => erros[id]);
    if (primeiro) {
        $(primeiro).focus();
    }
    return !!primeiro;
}

const _errosDe = regras => Object.fromEntries(Object.entries(regras).map(([id, regra]) => [id, regra()]));

// Com o erro na tela, ele some assim que a senha atende aos critérios (a lista embaixo já muda a cada tecla), e o da
// confirmação, quando as duas ficam iguais.
function _limparErroDaSenha(id, idConfirma, textoDiferentes) {
    const limpar = (campo, ok) => {
        if (campo?.getAttribute('aria-invalid') === 'true' && ok()) {
            _mostrarErro(campo.id, '');
        }
    };
    $(id)?.addEventListener('input', () => limpar($(id), () => senhaValida($(id).value)));
    // Só o erro de senhas diferentes: o do servidor (link vencido, falha) fica até o próximo envio.
    $(idConfirma)?.addEventListener('input', () => limpar($(idConfirma), () => $(idConfirma).value === $(id).value && $(`entE-${idConfirma}`)?.textContent.trim() === textoDiferentes));
}

// Botão ocupado (a roda do js/v2/botao.js) enquanto a chamada vai e volta: uma chamada por vez na tela (dois toques em
// contas diferentes não mandam duas).
let _emAndamento = false;
let _saindo = false;
window.addEventListener('pageshow', e => {
    if (e.persisted && _saindo) {
        _saindo = false;
        _congelar(document, false);
    }
});
// congelar: o formulário cujos campos não mudam durante o envio (vai o que foi conferido: um CEP trocado na espera iria com a
// cidade e a rua do anterior).
async function _comBotao(botao, tarefa, { congelar = null } = {}) {
    if (!botao || _emAndamento || ocupado(botao) || botao.getAttribute('aria-disabled') === 'true') {
        return undefined;
    }
    _emAndamento = true;
    ocupar(botao);
    _congelar(congelar, true);
    try {
        return await tarefa();
    } finally {
        _emAndamento = false;
        // Indo para outra página, o botão fica ocupado até ela abrir.
        if (!_saindo) {
            ocupar(botao, false);
            _congelar(congelar, false);
        }
    }
}

// Texto só leitura; caixa, opção, lista e arquivo desligados. Só destrava o que ela mesma travou.
function _congelar(form, ligar) {
    form?.querySelectorAll(ligar ? 'input:not([type="hidden"]), select, textarea' : '[data-congelado]').forEach(c => {
        const desligar = c.tagName === 'SELECT' || ['checkbox', 'radio', 'file'].includes(c.type);
        if (ligar && (desligar ? c.disabled : c.readOnly)) {
            return;
        }
        c.toggleAttribute('data-congelado', ligar);
        if (desligar) {
            c.disabled = ligar;
        } else {
            c.readOnly = ligar;
        }
    });
}

function _sairPara(endereco, { substituir = true } = {}) {
    _saindo = true;
    if (substituir) {
        window.location.replace(endereco);
    } else {
        window.location.assign(endereco);
    }
}

// Texto com o valor em negrito ({0}), sem HTML vindo de fora.
function _comDestaque(elemento, modelo, valor) {
    const [antes, depois = ''] = (modelo || '').split('{0}');
    const b = document.createElement('b');
    b.textContent = valor;
    elemento.replaceChildren(antes, b, depois);
}

function _alternarSenha(botao) {
    const campo = $(botao.dataset.entOlho);
    const mostrar = campo.type === 'password';
    campo.type = mostrar ? 'text' : 'password';
    botao.setAttribute('aria-pressed', String(mostrar));
    botao.setAttribute('aria-label', mostrar ? T.ocultarSenha : T.mostrarSenha);
    botao.querySelector('use').setAttribute('href', mostrar ? '#i-eye-slash' : '#i-eye');
}

function _avisoCaps(e) {
    const campo = e.target.closest?.('[data-ent-caps]');
    if (campo && typeof e.getModifierState === 'function') {
        $(campo.dataset.entCaps).hidden = !e.getModifierState('CapsLock');
    }
}

document.addEventListener('click', e => {
    const olho = e.target.closest('[data-ent-olho]');
    if (olho) {
        _alternarSenha(olho);
    }
});
document.addEventListener('keydown', _avisoCaps);
document.addEventListener('keyup', _avisoCaps);
document.addEventListener('focusout', e => {
    const campo = e.target.closest?.('[data-ent-caps]');
    if (campo) {
        $(campo.dataset.entCaps).hidden = true;
    }
});

// ---------- nova senha (link do e-mail) ----------
function _iniciarNovaSenha() {
    const form = $('entFormNova');
    const criterios = $('entNova') ? ligarCriteriosSenha($('entNova'), { textos: T.criterios, depoisDe: $('entNova').closest('.ent__senha') }) : null;
    _limparErroDaSenha('entNova', 'entNova2', T.senhaDiferente);
    form?.addEventListener('submit', async e => {
        e.preventDefault();
        const senha = $('entNova').value;
        const confirma = $('entNova2').value;
        // A regra nova (o servidor também confere) e a confirmação igual.
        const erroSenha = senhaValida(senha) ? '' : T.senhaCriterios;
        if (erroSenha) {
            criterios?.marcarFaltas();
        }
        const erroConfirma = !erroSenha && senha !== confirma ? T.senhaDiferente : '';
        _mostrarErro('entNova', erroSenha);
        _mostrarErro('entNova2', erroConfirma);
        _mostrarErro('nova', '');
        if (erroSenha || erroConfirma) {
            $(erroSenha ? 'entNova' : 'entNova2').focus();
            return;
        }
        await _comBotao(form.querySelector('[type="submit"]'), async () => {
            let r;
            try {
                r = await enviarFormulario(form.action, new FormData(form));
            } catch {
                _mostrarErro('nova', T.erroServidor);
                return;
            }
            // Com "Erro" a senha já foi trocada e o que falhou foi entrar logo depois (o link já venceu): a pessoa
            // entra pelo login com a senha nova.
            if (!_ok(r) && !r?.Erro) {
                _mostrarErro('nova', r?.Mensagem || r?.mensagem || T.erroServidor);
                return;
            }
            const entrou = _ok(r);
            const destino = entrou ? r.Redirect || url('/candidato/painel') : url('/login');
            $('entNovaContinuar').href = destino;
            if (!entrou) {
                $('entNovaContinuar').textContent = T.entrar;
                $('entNovaTexto').textContent = T.senhaAlteradaEntrar;
            }
            $$('.ent__passo', cartao).forEach(p => { p.hidden = p.dataset.passo !== 'ok'; });
            cartao.setAttribute('aria-labelledby', 'entT-ok');
            $('entT-ok').focus();
            if (entrou) {
                avisarLogin('login');
                setTimeout(() => _sairPara(destino), 1500);
            }
        });
    });
}

// ---------- campos do cartão (cadastro, currículo do cadastro e concluir cadastro) ----------

function _idade(data) {
    const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(data);
    if (!m) {
        return -1;
    }
    const nascimento = new Date(+m[3], +m[2] - 1, +m[1]);
    if (nascimento.getDate() !== +m[1] || nascimento.getMonth() !== +m[2] - 1 || +m[3] < 1900) {
        return -1;
    }
    const hoje = new Date();
    let anos = hoje.getFullYear() - nascimento.getFullYear();
    if (hoje < new Date(hoje.getFullYear(), nascimento.getMonth(), nascimento.getDate())) {
        anos--;
    }
    return anos;
}

function _cpfValido(cpf) {
    const d = _so(cpf);
    if (d.length !== 11 || /^(\d)\1+$/.test(d)) {
        return false;
    }
    const digito = n => {
        let soma = 0;
        for (let i = 0; i < n; i++) {
            soma += +d[i] * (n + 1 - i);
        }
        const resto = (soma * 10) % 11;
        return resto === 10 ? 0 : resto;
    };
    return digito(9) === +d[9] && digito(10) === +d[10];
}

// ---------- conta desativada: reativar (o servidor desconecta e a pessoa entra de novo) ----------
function _iniciarReativar() {
    const botao = $('entReativar');
    botao.addEventListener('click', () => _comBotao(botao, async () => {
        let r = null;
        try {
            r = await enviarFormulario(url('/PainelConfiguracoes/AtivarConta'), new FormData());
        } catch {
            r = null;
        }
        if (!_ok(r)) {
            avisarErro(r?.mensagem || T.erroServidor);
            return;
        }
        esquecerLogado();
        $$('.ent__passo', cartao).forEach(p => { p.hidden = p.dataset.passo !== 'ok'; });
        cartao.setAttribute('aria-labelledby', 'entT-ok');
        $('entT-ok').focus();
    }));
}

// ---------- saiu (/candidato/sair: o servidor já desconectou) ----------
// Tira do aparelho o que era da conta (a marca da lateral, as vagas salvas dela e o cache do v1), avisa as outras abas e vai ao
// início sem deixar o /candidato/sair no histórico.
function _iniciarSair() {
    esquecerLogado();
    sincronizarSalvas({ logado: false });
    try {
        sessionStorage.removeItem('usuarioLogado');
        // Rascunhos de Mensagens (mensagens-v2.js): texto da pessoa que saiu não fica no aparelho.
        Object.keys(localStorage).filter(chave => chave.startsWith('v2-msg-rascunho-')).forEach(chave => localStorage.removeItem(chave));
    } catch {
        // Sem armazenamento, o v1 também não guardou.
    }
    // Push de Mensagens: o aparelho para de receber (o redirecionamento abaixo espera 1 s; se cortar, o servidor já tirou a inscrição).
    esquecerAparelho();
    avisarLogin('logout');
    setTimeout(() => window.location.replace(url('')), 1000);
}

// ---------- termos novos: aceitar grava e segue para o ReturnUrl que o servidor conferiu ----------
function _iniciarTermos() {
    const caixa = $('entTermos');
    const botao = $('entTermosEnviar');
    caixa.addEventListener('change', () => _mostrarErro('entTermos', ''));
    $('entFormTermos').addEventListener('submit', e => {
        e.preventDefault();
        if (!caixa.checked) {
            _mostrarErro('entTermos', T.erroTermos);
            caixa.focus();
            return;
        }
        _comBotao(botao, async () => {
            const dados = new FormData();
            dados.append('ReturnUrl', new URLSearchParams(window.location.search).get('ReturnUrl') || '');
            let r = null;
            try {
                r = await enviarFormulario(url('/PainelNotificacoes/AtualizacaoTermos'), dados);
            } catch {
                r = null;
            }
            if (!_ok(r) || !r.redirect) {
                avisarErro(r?.mensagem || T.erroServidor);
                return;
            }
            _sairPara(r.redirect);
        });
    });
}

// ---------- matrícula de aluno: o servidor grava na empresa da vaga e devolve o destino conferido ----------
function _iniciarMatricula() {
    const form = $('entFormMatricula');
    const campo = $('entMatricula');
    const aviso = $('entMatNaoEnc');
    const regras = { entMatricula: () => (campo.value.trim() ? '' : T.erroMatricula) };
    _validarAoVivo(form, regras);
    campo.addEventListener('input', () => { aviso.hidden = true; });
    form.addEventListener('submit', e => {
        e.preventDefault();
        if (_mostrarErros(_errosDe(regras))) {
            return;
        }
        _comBotao($('entMatEnviar'), async () => {
            let r = null;
            try {
                r = await enviarFormulario(url('/HotSiteAluno/SaveMatricula'), new FormData(form));
            } catch {
                r = null;
            }
            // Erro do AlunoBusiness (matrícula vazia ou de outro cadastro) ou o teto do dia: embaixo do campo.
            if (r?.mensagem) {
                _mostrarErro('entMatricula', r.mensagem);
                // Destrava antes do foco (o finally do _comBotao só destrava depois): no campo só leitura, o teclado do celular
                // não abre e o leitor de tela anuncia "somente leitura".
                _congelar(form, false);
                campo.focus();
                return;
            }
            if (!_ok(r) || !r.redirect) {
                avisarErro(T.erroServidor);
                return;
            }
            if (!r.encontrada) {
                // Como na v1: o número fica para corrigir; o texto entra depois de mostrar, para o leitor de tela ler.
                const texto = aviso.firstElementChild;
                const t = texto.textContent;
                texto.textContent = '';
                aviso.hidden = false;
                requestAnimationFrame(() => { texto.textContent = t; });
                _congelar(form, false);
                campo.focus();
                return;
            }
            _sairPara(r.redirect);
        }, { congelar: form });
    });
}

// ---------- cadastro pendente (a empresa importou o currículo): ativar ou recusar, nos POSTs de hoje ----------
function _iniciarPendente() {
    const inicio = $('entPendente');
    const form = $('entFormPendente');
    const token = inicio.dataset.token;
    const passos = $$('.ent__passo', cartao);
    const mostrar = (passo, idTitulo) => {
        passos.forEach(p => { p.hidden = p.dataset.passo !== passo; });
        cartao.setAttribute('aria-labelledby', idTitulo);
        $(idTitulo).focus();
    };
    const criterios = ligarCriteriosSenha($('entPenSenha'), { textos: T.criterios, depoisDe: $('entPenSenha').closest('.ent__senha') });
    _mascarar($('entPenCpf'), 'cpf');
    if ($('entPenNasc')) {
        _mascarar($('entPenNasc'), 'data');
    }
    // O CPF é do Brasil (a mesma regra do servidor).
    const brasil = () => $('entPenPais').value === 'BR';
    $('entPenPais').addEventListener('change', () => {
        $('entPenCpfF').hidden = !brasil();
        if (!brasil()) {
            _mostrarErro('entPenCpf', '');
        }
    });

    const regras = {
        entPenNome: () => (_nomeValido(_nomeLimpo($('entPenNome').value)) ? '' : T.erroNome),
        entPenCpf: () => (brasil() && !_cpfValido($('entPenCpf').value) ? T.erroCpf : ''),
        entPenSenha: () => (senhaValida($('entPenSenha').value) ? '' : T.senhaCriterios),
        entPenTermos: () => ($('entPenTermos').checked ? '' : T.erroTermos)
    };
    if ($('entPenNasc')) {
        regras.entPenNasc = () => {
            const idade = _idade($('entPenNasc').value.trim());
            return idade < 0 ? T.erroNascimento : idade < 14 ? T.idadeMinima : '';
        };
    }
    if ($('entPenEmail')) {
        regras.entPenEmail = () => (_emailNovoValido($('entPenEmail').value.trim()) ? '' : T.erroEmail);
    }
    _validarAoVivo(form, regras, { entPenNasc: v => v.length === 10, entPenCpf: v => v.length === 14 });

    cartao.addEventListener('click', e => {
        if (e.target.closest('[data-ent-pendente-ativar]')) {
            mostrar('dados', 'entT-pendente-dados');
        } else if (e.target.closest('[data-ent-pendente-recusar]')) {
            _mostrarErro('recusar', '');
            mostrar('recusar', 'entT-pendente-recusar');
        } else if (e.target.closest('[data-ent-pendente-voltar]')) {
            mostrar('inicio', 'entT-pendente');
        } else if (e.target.closest('[data-ent-pendente-recusar-sim]')) {
            const botao = e.target.closest('[data-ent-pendente-recusar-sim]');
            _comBotao(botao, async () => {
                const dados = new FormData();
                dados.append('token', token);
                let r = null;
                try {
                    r = await enviarFormulario(url('/PainelCadastrar/ExcluirCadastroPendente'), dados);
                } catch {
                    r = null;
                }
                if (!_ok(r)) {
                    _mostrarErro('recusar', r?.mensagem || T.erroServidor);
                    return;
                }
                mostrar('recusado', 'entT-pendente-recusado');
            });
        }
    });

    form.addEventListener('submit', e => {
        e.preventDefault();
        _mostrarErro('pendente', '');
        const erros = _errosDe(regras);
        if (erros.entPenSenha) {
            criterios?.marcarFaltas();
        }
        if (_mostrarErros(erros)) {
            return;
        }
        // O servidor lê o nascimento em três campos (Dia, Mes, Ano), como o formulário de hoje.
        const [dia, mes, ano] = ($('entPenNasc')?.value.trim() || form.dataset.nascimento).split('/');
        const dados = new FormData();
        dados.append('token', token);
        dados.append('vagaIDOrigem', form.dataset.vaga || '');
        dados.append('nome', _nomeLimpo($('entPenNome').value));
        dados.append('Dia', dia);
        dados.append('Mes', mes);
        dados.append('Ano', ano);
        dados.append('PaisID', $('entPenPais').value);
        dados.append('cpf', brasil() ? $('entPenCpf').value : '');
        dados.append('email', $('entPenEmail')?.value.trim() || form.dataset.email);
        dados.append('senha', $('entPenSenha').value);
        dados.append('termosUso', 'True');
        _comBotao($('entPenEnviar'), async () => {
            let r = null;
            try {
                r = await enviarFormulario(url('/PainelCadastrar/CadastroPendente'), dados);
            } catch {
                r = null;
            }
            if (!_ok(r) || !r.url) {
                _mostrarErro('pendente', r?.mensagem || T.erroServidor);
                return;
            }
            registrarConversaoCadastro();
            _sairPara(r.url);
        });
    });
}

// ---------- telefones e endereço do cartão (concluir cadastro e dados de contato): js/v2/campos.js, com os textos daqui ----------
const _listaDeCidades = (campo, lista, aoEscolher) => _listaDeCidadesV2(campo, lista, aoEscolher, T.cidadeNenhuma);
const _erroDoFone = f => _erroDoFoneV2(f, T);

// ---------- concluir cadastro: só os dados que faltam, no SalvarDadosFaltantes de hoje ----------
function _iniciarConcluir() {
    const form = $('entFormConcluir');
    const itis = _ligarTelefones(['entConCel', 'entConTel', 'entConWa']);
    _mascarar($('entConCpf'), 'cpf');
    _mascarar($('entConNasc'), 'data');
    const temEndereco = !!$('paisID');
    const brasil = () => (temEndereco ? $('paisID').value === 'BR' : form.dataset.pais === 'BR');
    const pedeCpf = () => !!$('entConCpf') && brasil();
    // O CPF só é pedido no Brasil (a mesma regra do servidor). Sem nenhum campo à mostra, o título "Dados pessoais" sai junto.
    const dados = $('entConDados');
    const mostrarCpf = () => {
        if ($('entConCpfF')) {
            $('entConCpfF').hidden = !brasil();
        }
        if (dados) {
            dados.hidden = !$$('.ent__f', dados).some(campo => !campo.hidden);
        }
    };

    // Localização como na tela de antes: país, estado e cidade são <select>, e estado e cidade vêm do servidor pelo util de sempre
    // (selectCidades, que lê o URL_API e o CULTURE_EMPREGARE que a view define); o CEP só preenche a rua e o bairro.
    function ligarLocalizacao() {
        const pais = $('paisID');
        const estado = $('estadoID');
        const cidade = $('cidadeID');
        // Só aqui: o util traz o i18next e lê globais que só esta view tem.
        const util = import(/* webpackChunkName: "select-cidades" */ './utilidades/selectCidades');
        const carregar = async (tipo, id, select) => {
            try {
                await (await util).selectCidades(tipo, id, select, '');
            } catch {
                _mostrarErro('concluir', T.erroServidor);
            }
        };
        const prontos = (async () => {
            await carregar('estados', '', estado);
            await carregar('cidades', '', cidade);
        })();
        const dicaCep = $('entH-entConCep');
        pais.addEventListener('change', async () => {
            mostrarCpf();
            dicaCep.hidden = !brasil();
            await prontos;
            await carregar('estados', pais.value, estado);
        });
        estado.addEventListener('change', async () => {
            await prontos;
            await carregar('cidades', estado.value, cidade);
        });
        pais.dispatchEvent(new Event('change'));

        // O CEP (com máscara só no Brasil) acha a rua e o bairro; o estado e a cidade quem escolhe é a pessoa.
        const cep = $('entConCep');
        _mascarar(cep, 'cep', brasil);
        const indicador = _indicadorDeCep(cep, dicaCep, T);
        let buscado = '';
        async function buscarCep() {
            const digitos = _so(cep.value);
            buscado = digitos;
            const parar = indicador.iniciar();
            let r = null;
            let falhou = false;
            try {
                r = await obterJson(url(`/Home/BuscarCep?cep=${digitos}`));
            } catch {
                falhou = true;
            }
            parar();
            // O CEP mudou (ou o país) enquanto a busca ia: a resposta é de outro endereço.
            if (buscado !== digitos) {
                return;
            }
            if (falhou || !r || r.erro) {
                // Falha de rede ou de tempo não é CEP inexistente: o mesmo CEP pode ser buscado de novo.
                if (falhou) {
                    buscado = '';
                }
                dicaCep.textContent = (falhou && T.cepFalhou) || T.cepNaoEncontrado;
                return;
            }
            dicaCep.textContent = T.cvCepDica;
            mostrarErro(cep, '');
            if (r.logradouro) {
                $('entConLogradouro').value = r.logradouro;
                mostrarErro($('entConLogradouro'), '');
            }
            if (r.bairro) {
                $('entConBairro').value = r.bairro;
                mostrarErro($('entConBairro'), '');
            }
        }
        cep.addEventListener('input', () => {
            const digitos = _so(cep.value);
            if (!brasil()) {
                return;
            }
            // Outro CEP que não o buscado: a dica volta ao texto de antes, e o de 8 números é buscado.
            if (digitos !== buscado) {
                buscado = '';
                dicaCep.textContent = T.cvCepDica;
                if (digitos.length === 8) {
                    buscarCep();
                }
            }
        });

        // As regras da tela de antes: país, estado, cidade, rua e bairro sempre; o CEP, no Brasil.
        return {
            paisID: () => (pais.value ? '' : T.erroPais),
            estadoID: () => (estado.value ? '' : T.erroEstado),
            cidadeID: () => (cidade.value ? '' : T.erroCidade),
            entConCep: () => (!brasil() ? '' : !_so(cep.value) ? T.erroCep : _so(cep.value).length !== 8 ? T.erroCepInvalido : ''),
            entConBairro: () => ($('entConBairro').value.trim() ? '' : T.erroBairro),
            entConLogradouro: () => ($('entConLogradouro').value.trim() ? '' : T.erroLogradouro)
        };
    }
    const regrasEndereco = temEndereco ? ligarLocalizacao() : {};

    // Só os campos que a tela mostra; as mesmas regras no envio e em tempo real.
    const regras = {};
    if ($('entConCel')) {
        regras.entConCel = () => _erroDoFone(_fone(itis, 'entConCel'));
    }
    ['entConTel', 'entConWa'].filter(id => $(id)).forEach(id => {
        regras[id] = () => (_fone(itis, id).valor ? _erroDoFone(_fone(itis, id)) : '');
    });
    Object.assign(regras, regrasEndereco);
    if ($('entConNome')) {
        regras.entConNome = () => (_nomeValido(_nomeLimpo($('entConNome').value)) ? '' : T.erroNome);
    }
    if ($('entConCpf')) {
        regras.entConCpf = () => (pedeCpf() && !_cpfValido($('entConCpf').value) ? T.erroCpf : '');
    }
    if ($('entConNasc')) {
        regras.entConNasc = () => {
            const idade = _idade($('entConNasc').value.trim());
            return idade < 0 ? T.erroNascimento : idade < 14 ? T.idadeMinima : '';
        };
    }
    _validarAoVivo(form, regras, { entConNasc: v => v.length === 10, entConCpf: v => v.length === 14 });

    form.addEventListener('submit', e => {
        e.preventDefault();
        const cel = _fone(itis, 'entConCel');
        const nome = $('entConNome') ? _nomeLimpo($('entConNome').value) : '';
        const nascimento = $('entConNasc') ? $('entConNasc').value.trim() : '';
        _mostrarErro('concluir', '');
        if (_mostrarErros(_errosDe(regras))) {
            return;
        }

        const pessoa = {};
        if ($('entConCel')) {
            const tel = _fone(itis, 'entConTel');
            Object.assign(pessoa, { Celular: cel.valor, CelularPaisCode: `+${cel.ddi}`, Telefone: tel.valor, TelefonePaisCode: tel.valor ? `+${tel.ddi}` : '' });
        }
        if (temEndereco) {
            Object.assign(pessoa, {
                PaisID: $('paisID').value,
                EstadoID: +$('estadoID').value || 0,
                CidadeID: +$('cidadeID').value || 0,
                Cep: brasil() ? MASCARAS.cep($('entConCep').value) : $('entConCep').value.trim(),
                Bairro: $('entConBairro').value.trim(),
                Logradouro: $('entConLogradouro').value.trim()
            });
        }
        if ($('entConNome')) {
            pessoa.Nome = nome;
        }
        if (pedeCpf()) {
            pessoa.Cpf = $('entConCpf').value;
        }
        if ($('entConNasc')) {
            const [dia, mes, ano] = nascimento.split('/');
            pessoa.DataNascimento = `${ano}-${mes}-${dia}`;
        }
        const wa = _fone(itis, 'entConWa');
        const dados = {
            pessoa,
            whatsapp: wa.valor ? `+${wa.ddi} ${wa.valor}` : '',
            returnUrl: new URLSearchParams(window.location.search).get('ReturnUrl') || '',
            dadosFaltantes: JSON.parse(form.dataset.faltantes || '{}')
        };
        _comBotao($('entConEnviar'), async () => {
            let r = null;
            try {
                r = await enviarJson(url('/PainelNotificacoes/SalvarDadosFaltantes'), dados);
            } catch {
                r = null;
            }
            if (!_ok(r) || !r.redirect) {
                _mostrarErro('concluir', r?.mensagem || T.erroServidor);
                return;
            }
            _sairPara(r.redirect);
        });
    });
}

// ---------- dados de contato: confirmar como estão ou corrigir (os endpoints de hoje) ----------
function _iniciarContato() {
    const form = $('entFormContato');
    const volta = new URLSearchParams(window.location.search).get('ReturnUrl') || '';
    // A versão dos termos que a pessoa aceitou: o servidor passa pelos termos novos antes do destino.
    const versao = form.dataset.versao || '0';

    function ir(passo) {
        $$('.ent__passo', cartao).forEach(el => { el.hidden = el.dataset.passo !== passo; });
        cartao.setAttribute('aria-labelledby', `entT-${passo}`);
        $(`entT-${passo}`).focus();
    }

    $('entCtCorrigir').addEventListener('click', () => ir('editar'));
    // O resumo mostra o que está gravado: voltar descarta o que foi digitado (recarrega, com a bandeira de cada telefone).
    $('entCtVoltar').addEventListener('click', () => window.location.reload());

    const corretos = $('entCtCorretos');
    corretos?.addEventListener('click', () => _comBotao(corretos, async () => {
        const dados = new FormData();
        dados.append('ReturnUrl', volta);
        dados.append('versaoTermosDeUso', versao);
        let r = null;
        try {
            r = await enviarFormulario(url('/PainelNotificacoes/AtualizacaoDadosContinuarSemAlterar'), dados);
        } catch {
            r = null;
        }
        if (!_ok(r) || !r.redirect) {
            _mostrarErro('resumo', r?.mensagem || T.erroServidor);
            return;
        }
        _sairPara(r.redirect);
    }));

    // O formulário (regras e dados) é o mesmo da janela das Configurações (js/v2/campos.js); aqui só o envio, com o botão do cartão.
    ligarFormContato(form, T, volta, dados => _comBotao($('entCtEnviar'), async () => {
        let r = null;
        try {
            r = await enviarJson(url('/PainelNotificacoes/AtualizacaoDadosSalvar'), dados);
        } catch {
            r = null;
        }
        if (!_ok(r) || !r.redirect) {
            _mostrarErro('contato', r?.mensagem || T.erroServidor);
            return;
        }
        _sairPara(r.redirect);
    }));
}

// ---------- teste de perfil (Talentoday e eTalent): o teste do parceiro num quadro, em tela cheia ----------
// O link do Talentoday vem do servidor na hora (ele cria a pessoa no parceiro: robô e prévia de link não chegam a pedir); o do
// eTalent já veio na página. A mensagem do parceiro nunca aparece: na manutenção dele, ela é o HTML da página.
function _iniciarTeste() {
    const quadro = $('tstFrame');
    const carregando = $('tstCarregando');
    const painel = $('tstNaoAbriu');
    const aviso = $('tstNaoAbriuTexto');
    const textoAviso = aviso.textContent;
    const endereco = $('tstArea').dataset.endereco;
    // Só http(s): o link vem de fora.
    const valido = link => /^https?:\/\//i.test(link || '');

    // O src só entra depois de ouvir o load: o do quadro vazio já passou, e o próximo é o do teste.
    quadro.addEventListener('load', () => { carregando.hidden = true; });
    function abrir(link) {
        painel.hidden = true;
        carregando.hidden = false;
        quadro.hidden = false;
        quadro.src = link;
    }
    // O texto entra depois de mostrar, para o leitor de tela ler (também a cada nova falha).
    function naoAbriu() {
        carregando.hidden = true;
        quadro.hidden = true;
        painel.hidden = false;
        aviso.textContent = '';
        requestAnimationFrame(() => { aviso.textContent = textoAviso; });
    }
    async function pedir() {
        let r = null;
        try {
            r = await obterJson(url(endereco), { semCache: true });
        } catch {
            r = null;
        }
        if (_ok(r) && valido(r.url)) {
            abrir(r.url);
        } else {
            naoAbriu();
        }
    }

    $('tstTentar').addEventListener('click', e => {
        if (endereco) {
            _comBotao(e.currentTarget, pedir);
            return;
        }
        // eTalent: o link sai do servidor junto com a página. A roda fica até a página trocar, e o 2º clique não recarrega de novo
        // (no teste logado ainda sem link, cada carga pede um pré-cadastro ao parceiro).
        if (ocupado(e.currentTarget)) {
            return;
        }
        ocupar(e.currentTarget);
        window.location.reload();
    });
    if (endereco) {
        pedir();
    } else if (valido(quadro.dataset.src)) {
        abrir(quadro.dataset.src);
    } else {
        naoAbriu();
    }
}

// ---------- teste de perfil pelo link da empresa: os dados que o parceiro pede antes do teste (o ExternoSalvarPerfil de hoje) ----------
function _iniciarPerfil() {
    const form = $('entFormPerfil');
    const pais = $('paisID');
    const estado = $('estadoID');
    const cidade = $('cidadeID');
    _mascarar($('entPerNasc'), 'data');

    // País, estado e cidade como na tela de antes: estado e cidade vêm do servidor pelo util de sempre (selectCidades, que lê o
    // URL_API e o CULTURE_EMPREGARE da view). Sem país gravado, o da cultura da página.
    const util = import(/* webpackChunkName: "select-cidades" */ './utilidades/selectCidades');
    const carregar = async (tipo, id, select) => {
        try {
            await (await util).selectCidades(tipo, id, select, '');
        } catch {
            _mostrarErro('perfil', T.erroServidor);
        }
    };
    pais.addEventListener('change', () => carregar('estados', pais.value, estado));
    estado.addEventListener('change', () => carregar('cidades', estado.value, cidade));
    if (!pais.value) {
        pais.value = form.dataset.pais;
    }
    if (pais.value) {
        carregar('estados', pais.value, estado);
    }

    // Os obrigatórios da tela de antes; o nome segue a regra da plataforma e a data vai num campo só.
    const preenchido = (id, erro) => () => ($(id).value.trim() ? '' : erro);
    const regras = {
        entPerNome: () => (_nomeValido(_nomeLimpo($('entPerNome').value)) ? '' : T.erroNome),
        entPerNasc: () => (_idade($('entPerNasc').value.trim()) < 0 ? T.erroNascimento : ''),
        entPerGenero: preenchido('entPerGenero', T.erroGenero),
        paisID: preenchido('paisID', T.erroPais),
        estadoID: preenchido('estadoID', T.erroEstado),
        entPerEmpresa: preenchido('entPerEmpresa', T.erroEmpresa),
        entPerCargo: preenchido('entPerCargo', T.erroCargo)
    };
    _validarAoVivo(form, regras, { entPerNasc: v => v.length === 10 });

    form.addEventListener('submit', e => {
        e.preventDefault();
        _mostrarErro('perfil', '');
        if (_mostrarErros(_errosDe(regras))) {
            return;
        }
        // O servidor lê o nascimento em três campos (Dia, Mes, Ano), como o formulário de hoje. Os dados saem antes de congelar:
        // select desligado não entra no FormData.
        const [dia, mes, ano] = $('entPerNasc').value.trim().split('/');
        const dados = new FormData(form);
        dados.set('Nome', _nomeLimpo($('entPerNome').value));
        dados.append('Dia', dia);
        dados.append('Mes', mes);
        dados.append('Ano', ano);
        _comBotao($('entPerEnviar'), async () => {
            let r = null;
            try {
                r = await enviarFormulario(url('/PainelTalentoday/ExternoSalvarPerfil'), dados);
            } catch {
                r = null;
            }
            if (!_ok(r) || !r.id) {
                _mostrarErro('perfil', r?.mensagem || T.erroServidor);
                return;
            }
            _sairPara(url(`/assessment/${r.id}/responder`));
        }, { congelar: form });
    });
}

// ---------- entrar ----------
function _iniciarEntrar() {
    const OP = JSON.parse($('entOpcoes').textContent);
    const INICIAL = OP.passo;
    // O passo em que cada formulário está (para "Corrigir" e "Tentar com o CPF" voltarem a ele).
    const FORMULARIO = { entrar: 'entUsuario', recuperar: 'entUsuarioRec' };
    // Hotsite que cadastra o colaborador pelo ID externo da empresa: "colaborador" sempre; "ambos" pergunta antes do cadastro.
    const MODO_ID = cartao.dataset.idExterno || '';
    const E = {
        modo: INICIAL, // entrar | recuperar
        usuario: '',
        porEmail: false,
        pessoas: [],
        pessoa: null,
        sugestao: '',
        social: null,
        token: '',
        // 'quiz': "Perdi o acesso ao e-mail e ao celular" (com a conta identificada, vai às perguntas sem mandar o link)
        direto: '',
        celularFinal: '',
        canal: '',
        modoCodigo: 'recuperar',
        estadoGoogle: '',
        estadoLinkedin: '',
        quiz: { tipo: '', novoEmail: '', novoCelular: '', paisCode: '+55' },
        // cadastro: via = email | google | linkedin; cv = o passo do currículo completo
        // cep: o que a busca do CEP trouxe; semCep: "Não sei meu CEP"; cepFalhou: o CEP não foi achado (a lista aparece)
        // tipo: colaborador | candidato no hotsite do ID externo ('' até a escolha)
        cad: { via: 'email', email: '', cpf: '', nome: '', fotoUrl: '', pais: 'BR', cidadeID: 0, senha: '', sugestao: '', sugVisto: false, criada: false,
            cep: { buscado: '', cidadeID: 0, logradouro: '', bairro: '' }, semCep: false, cepFalhou: false, tipo: MODO_ID === 'colaborador' ? 'colaborador' : '' },
        cv: { novo: false, progresso: null, cidadeID: 0, estadoID: null, cepBuscado: '', endereco: null, preenchido: false, pais: 'BR', resumo: false, extra: null }
    };
    let _passo = INICIAL;
    let _depoisDeVoltar = null;
    const _vistos = new Set([INICIAL]);

    // ----- passos e histórico -----
    function _mostrar(passo, { focar = true } = {}) {
        $$('.ent__passo', cartao).forEach(p => { p.hidden = p.dataset.passo !== passo; });
        cartao.removeAttribute('aria-busy');
        _passo = passo;
        _vistos.add(passo);
        const titulo = $(`entT-${passo}`);
        if (titulo) {
            cartao.setAttribute('aria-labelledby', titulo.id);
        }
        // No passo de abertura, sem nada antes no histórico, não há para onde voltar.
        const semVolta = passo === INICIAL && !(history.state?.entN > 0);
        $$(`.ent__passo[data-passo="${passo}"] [data-ent-voltar]`).forEach(b => { b.hidden = semVolta; });
        if (focar) {
            const topo = cartao.getBoundingClientRect().top - (document.querySelector('.site-h')?.getBoundingClientRect().bottom || 0) - 12;
            if (topo < 0) {
                window.scrollBy({ top: topo, behavior: semAnimacao() ? 'auto' : 'smooth' });
            }
            // Onde a pessoa vai digitar, o foco vai direto ao campo.
            const campo = { senha: 'entSenha', quizContato: 'entNovoEmail', quizSenha: 'entQuizSenha', novo: E.cad.email ? 'entNovoNome' : 'entNovoEmail', dados: E.cad.via !== 'email' && !$('entDadosNomeF').hidden ? 'entDadosNome' : 'entNasc' }[passo];
            if (campo) {
                $(campo)?.focus({ preventScroll: true });
            } else if (passo === 'codigo') {
                $$('#entCod .ent__dig')[0].focus({ preventScroll: true });
            } else {
                titulo?.focus({ preventScroll: true });
            }
        }
        registrarEvento('login_passo', { passo });
        if (['novo', 'dados', 'curriculo'].includes(passo)) {
            _progresso(passo);
            registrarEvento('cadastro_passo', { passo, metodo: E.cad.via });
        }
    }

    // O estado da página sem as marcas das sobreposições do topo (menu, busca): fechar o menu não pode desfazer o passo.
    function _estadoBase() {
        return Object.fromEntries(Object.entries(history.state || {}).filter(([k]) => !k.startsWith('v2')));
    }

    function _ir(passo, { substituir = false } = {}) {
        // O mesmo passo de novo (o One Tap duas vezes, por exemplo) não empilha outra entrada.
        const trocar = substituir || passo === _passo;
        const n = history.state?.entN || 0;
        const estado = { ..._estadoBase(), entPasso: passo, entDe: trocar ? history.state?.entDe ?? null : _passo, entN: trocar ? n : n + 1 };
        if (trocar) {
            history.replaceState(estado, '');
        } else {
            history.pushState(estado, '');
        }
        _mostrar(passo);
    }

    function _voltar() {
        if (history.state?.entN > 0) {
            history.back();
            return;
        }
        _ir(INICIAL, { substituir: true });
    }

    // Volta ao passo do formulário (pelo histórico quando ele é o anterior) e faz algo nele.
    function _voltarPara(passo, depois) {
        if (history.state?.entDe === passo && history.state?.entN > 0) {
            _depoisDeVoltar = depois;
            history.back();
            return;
        }
        _ir(passo);
        depois?.();
    }

    window.addEventListener('popstate', e => {
        const passo = e.state?.entPasso;
        // O menu do topo também usa o histórico: fechar o menu não muda o passo.
        if (!passo || passo === _passo) {
            _depoisDeVoltar = null;
            return;
        }
        // Passo de outra visita (F5 e voltar): o que ele mostrava não está mais na memória.
        _mostrar(_vistos.has(passo) ? passo : INICIAL);
        const depois = _depoisDeVoltar;
        _depoisDeVoltar = null;
        depois?.();
    });

    // ----- endereço de volta, pendência e destino -----
    // O ReturnUrl da query, só do próprio site e nunca o próprio login (o servidor confere de novo).
    function _returnUrl() {
        const r = new URLSearchParams(window.location.search).get('ReturnUrl') || '';
        if (!_local(r)) {
            return '';
        }
        // A home também fica de fora: quem entra por ela vai ao Início da conta (o painel), como quem entra sem ReturnUrl.
        if (/^\/([a-z]{2}-[a-z]{2}\/?)?(\?.*)?$/i.test(r) && !/[?&]vaga=/i.test(r)) {
            return '';
        }
        return /\/(login|candidato\/esqueci-senha|candidato\/recuperar-senha)(\/|\?|$)/i.test(r) ? '' : r;
    }

    // Pela origem resolvida: o navegador apaga TAB e quebra de linha e lê "\" como "/", então "/\t/x.com" vira "//x.com".
    const _local = u => {
        if (typeof u !== 'string' || !u.startsWith('/') || /[\x00-\x1f\\]/.test(u)) {
            return false;
        }
        try {
            return new URL(u, window.location.origin).origin === window.location.origin;
        } catch {
            return false;
        }
    };

    // O login que começou no "Candidate-se" da v2: o ReturnUrl volta à vaga (na busca, com os filtros) pedindo a confirmação
    // (?confirmar=1). A vaga sai dele: ?vaga= na busca, na profissão e na empresa; o fim do caminho (_123) na página da vaga.
    function _volta() {
        const r = _returnUrl();
        if (!/[?&]confirmar=1(&|$)/.test(r)) {
            return null;
        }
        try {
            const u = new URL(r, window.location.origin);
            return { url: r, vagaID: u.searchParams.get('vaga') || /_(\d+)\/?$/.exec(u.pathname)?.[1] || '' };
        } catch {
            return null;
        }
    }

    // A vaga do "Candidate-se" (o mesmo contrato do v1). Vale 24 horas; sem data (gravada antes da v2), é velha. Só vale no login
    // que começou no "Candidate-se" dela: a que sobrou de outro dia ou de outra aba não leva este login para outra vaga nem envia
    // a candidatura sozinha.
    function _pendencia() {
        try {
            const p = JSON.parse(localStorage.getItem(PENDENCIA));
            if (!p || !p.vagaID || p.vagaID === '0' || !_local(p.url)) {
                return null;
            }
            if (!p.t || Date.now() - p.t > PENDENCIA_VALIDADE) {
                localStorage.removeItem(PENDENCIA);
                return null;
            }
            const v = _volta();
            return v && (!v.vagaID || v.vagaID === String(p.vagaID)) ? p : null;
        } catch {
            return null;
        }
    }

    // A vaga deste login: a da pendência ou, sem ela no aparelho, a do ReturnUrl.
    const _vagaDaVolta = () => _pendencia()?.vagaID || _volta()?.vagaID || '';
    // A recuperação por código e pelo questionário termina no servidor: ele leva o ReturnUrl até o fim.
    const _qsVolta = () => (_returnUrl() ? `?returnUrl=${encodeURIComponent(_returnUrl())}` : '');
    const _comToken = () => {
        const dados = new FormData();
        dados.append('token', E.token || '');
        return dados;
    };

    // Vindo do "Candidate-se", concluir cadastro e atualizar contato ficam para depois do envio (o quadro "Candidatura enviada"
    // pede); termos e matrícula continuam antes, com a vaga como destino final. Conta desativada não vai para a vaga.
    function _destinoComPendencia(redirect, final) {
        try {
            const u = new URL(redirect, window.location.origin);
            if (/\/candidato\/desativado$/i.test(u.pathname)) {
                return redirect;
            }
            if (/\/candidato\/(concluir-cadastro|atualizacao-contato)$/i.test(u.pathname)) {
                const depois = u.searchParams.get('ReturnUrl');
                return depois ? _destinoComPendencia(depois, final) : final;
            }
            if (!/\/candidato\/(termos|matricula)$/i.test(u.pathname)) {
                return final;
            }
            const interno = u.searchParams.get('ReturnUrl');
            u.searchParams.set('ReturnUrl', interno ? _destinoComPendencia(interno, final) : final);
            return u.pathname + u.search;
        } catch {
            return final;
        }
    }

    function _fuso() {
        try {
            return obterGeo()?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone || '';
        } catch {
            return '';
        }
    }

    async function _concluirLogin(redirect, metodo) {
        registrarEvento('login', { method: metodo });
        let destino = redirect || url('/candidato/painel');
        const volta = _volta();
        if (volta) {
            const vagaID = _vagaDaVolta();
            if (vagaID) {
                // O lembrete do servidor, como o v1 faz depois do login.
                const dados = new FormData();
                dados.append('vagaID', vagaID);
                try {
                    await fetch(url('/Vagas/SalvarCandidaturaPendente'), { method: 'POST', body: dados, credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
                } catch {
                    // O lembrete é ajuda: o login segue sem ele.
                }
            }
            destino = _destinoComPendencia(destino, volta.url);
            avisarLogin('login');
            // Sem etapa obrigatória no caminho, o currículo completo (quando a vaga pede e falta) vem antes de voltar à vaga.
            if (destino === volta.url && vagaID && await _precisaCurriculo(vagaID)) {
                await _irCurriculo({ novo: false });
                return;
            }
            _sairPara(destino);
            return;
        }
        avisarLogin('login');
        _sairPara(destino);
    }

    // ----- identificar (e-mail ou CPF antes da senha) -----
    const _pareceEmail = v => v.includes('@');

    function _formatarCpf(v) {
        const d = v.replace(/\D/g, '');
        return d.length === 11 ? `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}` : v;
    }

    // Só no fim (sair do campo ou enviar): formatar enquanto digita estragaria o e-mail que começa com números.
    function _normalizarUsuario(valor) {
        const v = valor.trim();
        return /^[\d.\-\s]+$/.test(v) ? _formatarCpf(v.replace(/\s/g, '')) : v;
    }

    async function _identificar(usuario, pessoaID = '') {
        const dados = new FormData();
        dados.append('usuario', usuario);
        if (pessoaID) {
            dados.append('pessoaID', pessoaID);
        }
        return enviarFormulario(url('/Login/IdentificarV2'), dados);
    }

    async function _enviarIdentificador(modo, botao) {
        const campoId = FORMULARIO[modo];
        const campo = $(campoId);
        const valor = _normalizarUsuario(campo.value);
        campo.value = valor;
        if (!valor) {
            _mostrarErro(campoId, T.erroVazio);
            campo.focus();
            return;
        }
        // Sem @ e com letras: não é e-mail nem CPF.
        if (!_pareceEmail(valor) && /[a-z]/i.test(valor)) {
            _mostrarErro(campoId, T.erroIdentificador);
            campo.focus();
            return;
        }
        _mostrarErro(campoId, '');
        // Chamado de outro passo ("Entrar com este CPF" do cadastro), o campo está escondido: o erro vem no aviso.
        const erro = texto => (_passo === modo ? _mostrarErro(campoId, texto) : avisarErro(texto));
        await _comBotao(botao, async () => {
            let r;
            try {
                r = await _identificar(valor);
            } catch {
                erro(T.erroServidor);
                return;
            }
            E.modo = modo;
            E.usuario = valor;
            E.porEmail = _pareceEmail(valor);
            E.pessoa = null;
            E.pessoas = [];
            E.social = null;
            if (!r?.sucesso) {
                if (r?.erro === 'EmailNaoEncontrado' || r?.erro === 'CpfNaoEncontrado') {
                    _naoEncontrado();
                } else if (r?.erro === 'UsuarioInvalido') {
                    erro(T.erroIdentificador);
                    campo.focus();
                } else if (r?.erro === 'ColaboradorNaoAutorizado') {
                    registrarEvento('login_erro', { tipo: 'colaboradornaoautorizado' });
                    erro(r.mensagem || T.erroServidor);
                    campo.focus();
                } else if (r?.erro === 'MuitasTentativas') {
                    registrarEvento('login_erro', { tipo: 'muitas_tentativas' });
                    erro(r.mensagem || T.erroServidor);
                } else {
                    erro(T.erroServidor);
                }
                return;
            }
            if (r.pessoas?.length) {
                E.pessoas = r.pessoas;
                _desenharContas();
                _ir('contas');
                return;
            }
            await _seguirComConta(r.semSenha);
        });
    }

    async function _seguirComConta(semSenha) {
        if (E.modo === 'recuperar') {
            await _pedirLink();
            return;
        }
        if (semSenha) {
            registrarEvento('login_erro', { tipo: 'sem_senha' });
            _mostrarErro('semSenha', '');
            _ir('semSenha');
            return;
        }
        _prepararSenha();
        _ir('senha');
    }

    // ----- várias contas com o mesmo e-mail -----
    function _foto(foto) {
        return foto && foto.trim() ? `https://storage.empregare.com/pessoas/${encodeURIComponent(foto)}` : 'https://storage.empregare.com/pessoas/sem-foto.png';
    }

    function _desenharContas() {
        _comDestaque($('entContasTexto'), T.contasTexto, E.usuario);
        $('entContas').replaceChildren(...E.pessoas.map(p => {
            const li = document.createElement('li');
            const botao = document.createElement('button');
            botao.type = 'button';
            botao.className = 'ent__conta';
            botao.dataset.entConta = p.ID;
            const img = document.createElement('img');
            img.className = 'ent__conta-foto';
            img.src = _foto(p.Foto);
            img.alt = '';
            img.width = 40;
            img.height = 40;
            img.loading = 'lazy';
            const texto = document.createElement('span');
            texto.className = 'ent__conta-t';
            const nome = document.createElement('b');
            nome.textContent = p.Nome || '';
            texto.append(nome);
            // O CPF ou o ID externo (mascarados no servidor) é o que separa contas com o mesmo nome.
            const doc = (p.Cpf || '').trim() || (p.IDExterno || '').trim();
            if (doc) {
                const small = document.createElement('small');
                small.textContent = doc;
                texto.append(small);
            }
            botao.append(img, texto);
            botao.insertAdjacentHTML('beforeend', '<svg class="ico" aria-hidden="true"><use href="#i-chevron-right"></use></svg>');
            li.append(botao);
            return li;
        }));
    }

    async function _escolherConta(botao) {
        const pessoa = E.pessoas.find(p => p.ID === botao.dataset.entConta);
        // Com outra conta ainda a caminho, o segundo toque não troca a conta escolhida.
        if (!pessoa || _emAndamento) {
            return;
        }
        E.pessoa = pessoa;
        if (E.social) {
            await _comBotao(botao, _entrarSocialComConta);
            return;
        }
        if (E.modo === 'recuperar') {
            await _comBotao(botao, _pedirLink);
            return;
        }
        // A conta escolhida pode não ter senha (cadastrada pela empresa, por exemplo).
        await _comBotao(botao, async () => {
            let r;
            try {
                r = await _identificar(E.usuario, pessoa.ID);
            } catch {
                avisarErro(T.erroServidor);
                return;
            }
            if (!r?.sucesso) {
                avisarErro(r?.mensagem || T.erroServidor);
                return;
            }
            await _seguirComConta(r.semSenha);
        });
    }

    // ----- senha -----
    function _prepararSenha() {
        E.modo = 'entrar';
        const foto = $('entQuemFoto');
        $('entQuem').textContent = E.pessoa ? E.pessoa.Nome : E.usuario;
        foto.hidden = !E.pessoa;
        if (E.pessoa) {
            foto.src = _foto(E.pessoa.Foto);
        }
        $('entUsuarioSenha').value = E.usuario;
        $('entSenha').value = '';
        _mostrarErro('entSenha', '');
    }

    function _erroDeSenha(r) {
        const restantes = r?.TentativasRestantes;
        const bloqueado = restantes === 0 || r?.Erro === 'Acesso bloqueado';
        let texto = T.senhaIncorreta;
        if (bloqueado) {
            texto = T.bloqueado;
        } else if (restantes > 0 && restantes <= 3) {
            texto = `${T.senhaIncorreta} ${restantes === 1 ? T.tentativa : formatar(T.tentativas, restantes)}`;
        }
        registrarEvento('login_erro', { tipo: bloqueado ? 'bloqueado' : 'senha_incorreta' });
        _mostrarErro('entSenha', texto);
        const campo = $('entSenha');
        campo.value = '';
        campo.focus();
    }

    function _tratarLogin(r, metodo) {
        if (_ok(r)) {
            return _concluirLogin(r.Redirect, metodo);
        }
        if (r?.Pessoas?.length) {
            E.pessoas = r.Pessoas;
            _desenharContas();
            _ir('contas');
            return undefined;
        }
        switch (r?.Erro) {
            case 'SenhaIncorreta':
            case 'Acesso bloqueado':
                _erroDeSenha(r);
                break;
            case 'SoliciteEsqueciSenha':
                registrarEvento('login_erro', { tipo: 'sem_senha' });
                _ir('semSenha');
                break;
            case 'EmailNaoEncontrado':
            case 'CpfNaoEncontrado':
                _naoEncontrado();
                break;
            default:
                // Colaborador fora do site da empresa, cadastro banido, erro do servidor: a mensagem do v1.
                registrarEvento('login_erro', { tipo: (r?.Erro || 'erro').toLowerCase() });
                if (_passo === 'senha') {
                    _mostrarErro('entSenha', r?.Mensagem || r?.mensagem || T.erroServidor);
                } else {
                    avisarErro(r?.Mensagem || r?.mensagem || T.erroServidor);
                }
        }
        return undefined;
    }

    async function _entrarComSenha(botao) {
        const senha = $('entSenha').value;
        if (!senha) {
            _mostrarErro('entSenha', T.senhaVazia);
            $('entSenha').focus();
            return;
        }
        _mostrarErro('entSenha', '');
        const dados = new FormData();
        dados.append('Usuario', E.usuario);
        dados.append('Senha', senha);
        dados.append('PessoaID', E.pessoa?.ID || '');
        dados.append('ReturnUrl', _returnUrl());
        dados.append('TimeZone', _fuso());
        await _comBotao(botao, async () => {
            let r;
            try {
                r = await enviarFormulario(url('/Login/Autenticar'), dados);
            } catch {
                _mostrarErro('entSenha', T.erroServidor);
                return;
            }
            await _tratarLogin(r, 'senha');
        });
    }

    // ----- não encontrado (com a sugestão para e-mail digitado errado) -----
    function _naoEncontrado() {
        if (E.modo !== 'recuperar') {
            registrarEvento('login_erro', { tipo: 'nao_encontrado', identificador: E.porEmail ? 'email' : 'cpf', modo: E.modo });
            _comecarCadastro({ usuario: E.usuario, porEmail: E.porEmail });
            return;
        }
        $('entT-nao').textContent = E.porEmail ? T.naoEmail : T.naoCpf;
        $('entNaoAlvo').textContent = E.usuario;
        $('entNaoDica').textContent = E.porEmail ? T.dicaCpf : T.dicaEmail;
        cartao.querySelector('[data-ent-outro]').textContent = E.porEmail ? T.tentarCpf : T.tentarEmail;
        E.sugestao = E.porEmail ? _sugerirEmail(E.usuario) : '';
        $('entSug').hidden = !E.sugestao;
        if (E.sugestao) {
            _comDestaque($('entSugTexto'), T.quisDizer, E.sugestao);
        }
        registrarEvento('login_erro', { tipo: 'nao_encontrado', identificador: E.porEmail ? 'email' : 'cpf', modo: E.modo });
        _ir('nao');
    }

    // ----- recuperar a senha -----
    function _erroNoPasso(texto) {
        const alvo = { recuperar: 'entUsuarioRec', senha: 'entSenha', semSenha: 'semSenha' }[_passo];
        if (alvo) {
            _mostrarErro(alvo, texto);
        } else {
            avisarErro(texto);
        }
    }

    async function _pedirLink() {
        const dados = new FormData();
        dados.append('emailCpf', E.usuario);
        if (E.pessoa) {
            dados.append('id', E.pessoa.ID);
        }
        let r;
        try {
            r = await enviarFormulario(url('/candidato/esqueci-senha'), dados);
        } catch {
            _erroNoPasso(T.erroServidor);
            return;
        }
        if (!r?.sucesso) {
            _erroNoPasso(r?.mensagem || T.erroServidor);
            return;
        }
        if (r.pessoas?.length) {
            E.modo = 'recuperar';
            E.pessoas = r.pessoas;
            _desenharContas();
            _ir('contas');
            return;
        }
        E.token = r.token;
        if (E.direto === 'quiz') {
            await _abrirQuiz();
            return;
        }
        await _enviarEmail();
    }

    const PROVEDORES = [
        [/^(gmail|googlemail)\.com$/, 'Gmail', 'https://mail.google.com/mail/u/0/#search/empregare'],
        [/^(hotmail|outlook|live|msn)\.com(\.br)?$/, 'Outlook', 'https://outlook.live.com/mail/0/'],
        [/^yahoo\.com(\.br)?$/, 'Yahoo Mail', 'https://mail.yahoo.com/'],
        [/^(icloud|me)\.com$/, 'iCloud Mail', 'https://www.icloud.com/mail']
    ];

    async function _enviarEmail({ reenvio = false } = {}) {
        const dados = new FormData();
        dados.append('token', E.token);
        // A volta depois da nova senha: onde a pessoa estava (a vaga do "Candidate-se", já pedindo a confirmação).
        const final = _returnUrl();
        const vagaID = _vagaDaVolta();
        if (vagaID) {
            dados.append('vagaID', vagaID);
        }
        if (final) {
            dados.append('redirect', final);
        }
        let r;
        try {
            r = await enviarFormulario(url('/Login/AlterarSenhaViaEmail'), dados);
        } catch {
            _erroNoPasso(T.erroServidor);
            return false;
        }
        if (!r?.sucesso) {
            _erroNoPasso(r?.mensagem || T.erroServidor);
            return false;
        }
        // Cadastro sem e-mail: não há link para conferir, o caminho é o celular.
        if (!r.email) {
            await _buscarCelular();
            return true;
        }
        _comDestaque($('entEmailTexto'), T.emailTexto, r.email);
        const dominio = (r.email || '').split('@')[1]?.toLowerCase() || '';
        const provedor = PROVEDORES.find(([re]) => re.test(dominio));
        const abrir = $('entAbrirEmail');
        abrir.hidden = !provedor;
        if (provedor) {
            abrir.href = provedor[2];
            abrir.textContent = formatar(T.abrirEmail, provedor[1]);
        }
        if (reenvio) {
            avisarSucesso(T.reenviado);
        } else {
            registrarEvento('recuperacao_senha', { canal: 'email', etapa: 'enviado' });
            _ir('email');
            _esperar($('entReenviar'), 60, T.reenviar, T.reenviarEm);
        }
        return true;
    }

    // Contagem para reenviar (aria-disabled: quem acabou de tocar não perde o foco).
    const _esperas = new Map();
    function _esperar(botao, segundos, texto, modelo) {
        clearInterval(_esperas.get(botao));
        let s = segundos;
        botao.setAttribute('aria-disabled', 'true');
        botao.textContent = formatar(modelo, s);
        _esperas.set(botao, setInterval(() => {
            s--;
            if (s <= 0) {
                clearInterval(_esperas.get(botao));
                botao.removeAttribute('aria-disabled');
                botao.textContent = texto;
            } else {
                botao.textContent = formatar(modelo, s);
            }
        }, 1000));
    }

    async function _buscarCelular() {
        let r;
        try {
            r = await enviarFormulario(url('/Login/ObterCelularSMS'), _comToken());
        } catch {
            avisarErro(T.erroServidor);
            return;
        }
        if (!r?.sucesso) {
            _ir('semCelular');
            return;
        }
        E.celularFinal = r.celularFinal;
        _comDestaque($('entWhatsTexto'), T.whatsTexto, r.celularFinal);
        _mostrarErro('whats', '');
        $('entWhatsSuporte').hidden = true;
        _ir('whats');
    }

    // WhatsApp primeiro e SMS de reserva: quem decide é o servidor, que devolve o canal usado.
    async function _enviarCodigo() {
        const erroId = _passo === 'codigo' ? 'codigo' : 'whats';
        let r;
        try {
            r = await enviarFormulario(url('/Login/VerificarCelularSMS'), _comToken());
        } catch {
            _mostrarErro(erroId, T.erroServidor);
            return false;
        }
        if (!r?.sucesso) {
            _mostrarErro(erroId, r?.mensagem || T.erroServidor);
            if (r?.limiteTentativas) {
                $(erroId === 'codigo' ? 'entCodigoSuporte' : 'entWhatsSuporte').hidden = false;
            }
            return false;
        }
        E.canal = r.canal === 'whatsapp' ? 'whatsapp' : 'sms';
        E.celularFinal = r.celularFinal || E.celularFinal;
        E.modoCodigo = 'recuperar';
        registrarEvento('recuperacao_senha', { canal: E.canal, etapa: 'codigo_enviado' });
        _prepararCodigo();
        if (_passo !== 'codigo') {
            _ir('codigo');
        }
        _esperar($('entReenviarCodigo'), 30, T.reenviarCodigo, T.reenviarCodigoEm);
        return true;
    }

    // ----- código de 6 números -----
    const _digitos = () => $$('#entCod .ent__dig');

    function _prepararCodigo() {
        const whats = E.canal === 'whatsapp';
        $('entT-codigo').textContent = whats ? T.codigoTituloWhats : T.codigoTituloSms;
        _comDestaque($('entCodigoTexto'), whats ? T.codigoTextoWhats : T.codigoTextoSms, E.celularFinal || '');
        _digitos().forEach(d => { d.value = ''; d.disabled = false; });
        _mostrarErro('codigo', '');
        $('entCodigoSuporte').hidden = true;
        // O código do celular novo (questionário) não tem reenvio, como no v1.
        $('entReenviarCodigo').hidden = E.modoCodigo === 'quiz';
    }

    function _distribuir(inicio, texto) {
        const digitos = _digitos();
        [...texto].slice(0, digitos.length - inicio).forEach((c, k) => { digitos[inicio + k].value = c; });
        const proximo = digitos.find(d => !d.value);
        (proximo || digitos[digitos.length - 1]).focus();
        const codigo = digitos.map(d => d.value).join('');
        if (codigo.length === digitos.length) {
            _validarCodigo(codigo);
        }
    }

    async function _validarCodigo(codigo) {
        const digitos = _digitos();
        digitos.forEach(d => { d.disabled = true; });
        const limpar = texto => {
            _mostrarErro('codigo', texto);
            digitos.forEach(d => { d.disabled = false; d.value = ''; });
            digitos[0].focus();
        };
        try {
            if (E.modoCodigo === 'quiz') {
                const r = await enviarJson(url('/Login/ConfirmarSMSNovoCelularRecuperarAcesso'), {
                    Token: E.token, Codigo: codigo, NovoCelular: E.quiz.novoCelular, NovoCelularPaisCode: E.quiz.paisCode
                });
                if (!r?.sucesso) {
                    limpar(r?.mensagem || T.codigoInvalido);
                    return;
                }
                digitos.forEach(d => { d.disabled = false; });
                _ir('quizSenha');
                return;
            }
            const r = await enviarJson(url(`/Login/ValidarCodigoSMS${_qsVolta()}`), { Token: E.token, Codigo: codigo });
            if (!r?.sucesso) {
                limpar(r?.mensagem || T.codigoInvalido);
                return;
            }
            // Como no v1: a resposta já entrou na conta (cookie) e a troca de senha leva à atualização do contato.
            registrarEvento('recuperacao_senha', { canal: E.canal, etapa: 'codigo_ok' });
            avisarLogin('login');
            _sairPara(r.redirectUrl, { substituir: false });
        } catch {
            limpar(T.erroServidor);
        }
    }

    // ----- questionário (quando ligado no servidor) -----
    let _respostaQuiz = null;
    async function _desenharPergunta(p) {
        if (!p || p.tipo === 'Finalizou') {
            await _prepararContato();
            _ir('quizContato');
            return false;
        }
        // As bibliotecas antes de mexer na tela: se o download falhar, a pergunta anterior continua de pé.
        const libs = ['Cpf', 'DataNascimento', 'TelefoneAntigo'].includes(p.tipo) ? await _carregarBibliotecas() : null;
        E.quiz.tipo = p.tipo;
        $('entT-quiz').textContent = p.titulo || '';
        const sub = $('entQuizSub');
        sub.hidden = p.tipo !== 'Nome';
        sub.textContent = T.quizNomeSub;
        _mostrarErro('quiz', '');
        const area = $('entQuizCampo');
        _respostaQuiz = null;

        if (Array.isArray(p.alternativas) && p.alternativas.length) {
            const grupo = document.createElement('fieldset');
            grupo.className = 'ent__alts';
            const legenda = document.createElement('legend');
            legenda.className = 'sr';
            legenda.textContent = p.titulo || '';
            grupo.append(legenda);
            p.alternativas.forEach(alt => {
                const rotulo = document.createElement('label');
                rotulo.className = 'ent__alt';
                const radio = document.createElement('input');
                radio.type = 'radio';
                radio.name = 'entQuizAlt';
                radio.value = alt;
                const texto = document.createElement('span');
                texto.textContent = alt;
                rotulo.append(radio, texto);
                grupo.append(rotulo);
            });
            area.replaceChildren(grupo);
            _respostaQuiz = () => {
                const marcada = area.querySelector('input[name="entQuizAlt"]:checked');
                return marcada ? { valor: marcada.value } : { erro: T.quizSelecione };
            };
            return true;
        }

        const campo = document.createElement('input');
        campo.className = 'ent__in';
        campo.id = 'entQuizResp';
        campo.autocomplete = 'off';
        campo.setAttribute('aria-labelledby', 'entT-quiz');
        campo.setAttribute('aria-describedby', 'entE-quiz');
        area.replaceChildren(campo);

        if (p.tipo === 'Cpf') {
            campo.inputMode = 'numeric';
            campo.placeholder = '000.000.000-00';
            libs.IMask(campo, { mask: '000.000.000-00' });
            _respostaQuiz = () => (campo.value.replace(/\D/g, '').length === 11 ? { valor: campo.value.trim() } : { erro: T.quizCpf });
        } else if (p.tipo === 'DataNascimento') {
            // Digitada com máscara (dd/mm/aaaa, o formato que o v1 manda); para nascimento é mais rápido que o calendário.
            campo.inputMode = 'numeric';
            campo.placeholder = 'dd/mm/aaaa';
            libs.IMask(campo, { mask: '00/00/0000' });
            _respostaQuiz = () => {
                const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(campo.value);
                const data = m ? new Date(+m[3], +m[2] - 1, +m[1]) : null;
                const valida = data && data.getDate() === +m[1] && data.getMonth() === +m[2] - 1 && +m[3] >= 1900 && data <= new Date();
                return valida ? { valor: campo.value } : { erro: T.quizData };
            };
        } else if (p.tipo === 'TelefoneAntigo') {
            campo.type = 'tel';
            campo.inputMode = 'tel';
            const iti = _telefone(campo, libs);
            _respostaQuiz = () => {
                const numero = iti.getNumber();
                if (!numero) {
                    return { erro: T.quizPreencha };
                }
                return typeof iti.isValidNumber === 'function' && !iti.isValidNumber() ? { erro: T.quizCelular } : { valor: numero };
            };
        } else {
            if (p.tipo === 'EmailAntigo') {
                campo.type = 'email';
                campo.inputMode = 'email';
                campo.placeholder = 'exemplo@dominio.com';
            } else if (p.tipo === 'Nome') {
                campo.placeholder = T.quizNome;
            }
            _respostaQuiz = () => (campo.value.trim() ? { valor: campo.value.trim() } : { erro: T.quizPreencha });
        }
        return true;
    }

    // Sem o _comBotao: o "Perdi o acesso ao e-mail e ao celular" chega aqui já dentro do botão dele (_pedirLink).
    async function _abrirQuiz() {
        let r;
        try {
            r = await enviarFormulario(url('/Login/IniciarRecuperarAcesso'), _comToken());
        } catch {
            avisarErro(T.quizErro);
            return;
        }
        if (r?.sucesso) {
            registrarEvento('recuperacao_senha', { canal: 'questionario', etapa: E.direto === 'quiz' ? 'iniciado_direto' : 'iniciado' });
            try {
                if (await _desenharPergunta(r.pergunta)) {
                    _ir('quiz');
                    $('entQuizResp')?.focus();
                }
            } catch {
                avisarErro(T.quizErro);
            }
            return;
        }
        // Fora do Brasil ou sem dados que bastem para as perguntas: o passo que leva ao suporte.
        if (r?.codigo === 'INDISPONIVEL_PAIS' || r?.codigo === 'SEM_DADOS') {
            $('entT-quizPais').textContent = r.titulo || T.quizPaisTitulo;
            $('entQuizPaisTexto').textContent = r.mensagem || T.quizPaisTexto;
            $('entQuizPaisBotao').textContent = r.botaoSuporte || T.quizPaisBotao;
            _ir('quizPais');
            return;
        }
        avisarErro(r?.mensagem || T.quizErro);
    }

    async function _iniciarQuiz(botao) {
        await _comBotao(botao, _abrirQuiz);
    }

    async function _responderQuiz(botao) {
        const resposta = _respostaQuiz?.();
        if (!resposta || resposta.erro) {
            _mostrarErro('quiz', resposta?.erro || T.quizPreencha);
            return;
        }
        _mostrarErro('quiz', '');
        await _comBotao(botao, async () => {
            let r;
            try {
                r = await enviarJson(url('/Login/ResponderRecuperarAcesso'), { Token: E.token, TipoPergunta: E.quiz.tipo, Resposta: resposta.valor });
            } catch {
                _mostrarErro('quiz', T.quizErro);
                return;
            }
            if (!r?.sucesso) {
                _mostrarErro('quiz', r?.mensagem || T.quizErro);
                return;
            }
            try {
                if (r.finalizou) {
                    await _desenharPergunta(null);
                    return;
                }
                // A pergunta seguinte entra no mesmo passo (como no v1).
                if (await _desenharPergunta(r.pergunta)) {
                    ($('entQuizResp') || $('entT-quiz')).focus();
                }
            } catch {
                _mostrarErro('quiz', T.quizErro);
            }
        });
    }

    let _itiContato = null;
    async function _prepararContato() {
        _mostrarErro('quizContato', '');
        if (_itiContato) {
            return;
        }
        try {
            _itiContato = _telefone($('entNovoCel'), await _carregarBibliotecas());
        } catch {
            // Sem a biblioteca, o celular vai como digitado (com o DDI do Brasil, como o v1).
        }
    }

    // Sem o botão (HTML de antes na borda com o JS novo), segue só com o texto.
    function _mostrarSuporteContato(mostrar) {
        const suporte = $('entQuizContatoSuporte');
        if (suporte) {
            suporte.hidden = !mostrar;
        }
    }

    async function _enviarContato(botao) {
        const email = $('entNovoEmail').value.trim();
        const confirma = $('entNovoEmail2').value.trim();
        const celular = $('entNovoCel').value.trim();
        const ddi = _itiContato?.getSelectedCountryData()?.dialCode;
        const paisCode = ddi ? `+${ddi}` : '+55';
        let erro = '';
        if (celular && _itiContato && typeof _itiContato.isValidNumber === 'function' && !_itiContato.isValidNumber()) {
            erro = T.quizCelular;
        } else if (!email || !confirma || !celular) {
            erro = T.quizPreencha;
        } else if (email !== confirma) {
            erro = T.quizEmailDiferente;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            erro = T.quizEmail;
        }
        _mostrarErro('quizContato', erro);
        _mostrarSuporteContato(false);
        if (erro) {
            return;
        }
        E.quiz = { ...E.quiz, novoEmail: email, novoCelular: celular, paisCode };
        await _comBotao(botao, async () => {
            const corpo = { Token: E.token, NovoEmail: email, NovoCelular: celular, NovoCelularPaisCode: paisCode };
            try {
                const r = await enviarJson(url('/Login/ValidarNovoContatoRecuperarAcesso'), corpo);
                if (!r?.sucesso) {
                    _mostrarErro('quizContato', r?.mensagem || T.quizErro);
                    return;
                }
                const sms = await enviarJson(url('/Login/EnviarSMSNovoCelularRecuperarAcesso'), { Token: E.token, NovoCelular: celular, NovoCelularPaisCode: paisCode });
                if (!sms?.sucesso) {
                    _mostrarErro('quizContato', sms?.mensagem || T.quizErro);
                    // O limite do dia (o mesmo do código do celular do cadastro): o caminho que resta é o suporte.
                    _mostrarSuporteContato(!!sms?.limiteTentativas);
                    return;
                }
                E.modoCodigo = 'quiz';
                // WhatsApp primeiro e SMS de reserva: o servidor diz por onde foi (como no código do celular do cadastro).
                E.canal = sms.canal === 'whatsapp' ? 'whatsapp' : 'sms';
                E.celularFinal = sms.celularFinal;
                _prepararCodigo();
                _ir('codigo');
            } catch {
                _mostrarErro('quizContato', T.quizErro);
            }
        });
    }

    async function _concluirQuiz(botao) {
        const senha = $('entQuizSenha').value;
        const confirma = $('entQuizSenha2').value;
        const erroSenha = senhaValida(senha) ? '' : T.senhaCriterios;
        if (erroSenha) {
            _critQuiz?.marcarFaltas();
        }
        const erroConfirma = !erroSenha && senha !== confirma ? T.quizSenhaDiferente : '';
        _mostrarErro('entQuizSenha', erroSenha);
        _mostrarErro('entQuizSenha2', erroConfirma);
        if (erroSenha || erroConfirma) {
            $(erroSenha ? 'entQuizSenha' : 'entQuizSenha2').focus();
            return;
        }
        await _comBotao(botao, async () => {
            let r;
            try {
                r = await enviarJson(url(`/Login/FinalizarRecuperarAcesso${_qsVolta()}`), {
                    Token: E.token, NovoEmail: E.quiz.novoEmail, NovoCelular: E.quiz.novoCelular, NovoCelularPaisCode: E.quiz.paisCode, NovaSenha: senha
                });
            } catch {
                _mostrarErro('entQuizSenha2', T.quizErro);
                return;
            }
            if (!r?.sucesso) {
                _mostrarErro('entQuizSenha2', r?.mensagem || T.quizErro);
                return;
            }
            registrarEvento('recuperacao_senha', { canal: 'questionario', etapa: 'concluida' });
            avisarLogin('login');
            _sairPara(r.redirectUrl, { substituir: false });
        });
    }

    // ----- Google e LinkedIn (a janela de hoje: GoogleRedirect/LinkedinRedirect avisam esta página por postMessage) -----
    function _aleatorio() {
        const bytes = new Uint8Array(16);
        crypto.getRandomValues(bytes);
        return [...bytes].map(b => b.toString(16).padStart(2, '0')).join('');
    }

    function _janela(endereco, nome) {
        const largura = 500;
        const altura = 600;
        const esquerda = (window.screen.width - largura) / 2;
        const topo = (window.screen.height - altura) / 2;
        const janela = window.open(endereco, nome, `width=${largura},height=${altura},top=${topo},left=${esquerda}`);
        if (!janela) {
            avisarErro(T.janelaBloqueada);
        }
    }

    function _abrirGoogle() {
        const g = OP.google || {};
        if (!g.cliente || !g.retorno) {
            avisarErro(formatar(T.erroSocial, 'Google'));
            return;
        }
        // A origem vai no fim do state: a janela de retorno só entrega o token a ela.
        E.estadoGoogle = `${_aleatorio()}|${window.location.origin}`;
        const endereco = `https://accounts.google.com/o/oauth2/auth?state=${encodeURIComponent(E.estadoGoogle)}&client_id=${encodeURIComponent(g.cliente)}`
            + `&redirect_uri=${encodeURIComponent(g.retorno)}&scope=${encodeURIComponent('email profile')}&response_type=code`;
        _janela(endereco, 'Google Login');
    }

    function _abrirLinkedin() {
        E.estadoLinkedin = _aleatorio();
        _janela(`${OP.linkedin}?estado=${E.estadoLinkedin}`, 'Linkedin Login');
    }

    // A janela volta pelo endereço cadastrado no Google/LinkedIn (o www): no hotsite, a origem é outro subdomínio.
    function _origemConfiavel(origem) {
        if (origem === window.location.origin) {
            return true;
        }
        try {
            const u = new URL(origem);
            if (u.protocol === 'https:' && (u.hostname === 'empregare.com' || u.hostname.endsWith('.empregare.com'))) {
                return true;
            }
            return window.location.hostname === 'localhost' && u.hostname === 'localhost';
        } catch {
            return false;
        }
    }

    window.addEventListener('message', e => {
        const tipo = e.data?.type;
        if (typeof tipo !== 'string' || !_origemConfiavel(e.origin)) {
            return;
        }
        const resposta = e.data.response || {};
        if (tipo === 'googleAutenticacaoSucesso' || tipo === 'linkedinAutenticacaoSucesso') {
            const google = tipo.startsWith('google');
            const esperado = google ? E.estadoGoogle : E.estadoLinkedin;
            const recebido = google ? resposta.state : String(resposta.state || '').split('|')[0];
            if (google) {
                E.estadoGoogle = '';
            } else {
                E.estadoLinkedin = '';
            }
            if (!esperado || recebido !== esperado || !resposta.credential) {
                avisarErro(formatar(T.erroSocial, google ? 'Google' : 'LinkedIn'));
                return;
            }
            _validarSocial(google ? 'Google' : 'LinkedIn', resposta.credential);
        } else if (tipo === 'googleAutenticacaoErro' || tipo === 'linkedinAutenticacaoErro') {
            avisarErro(formatar(T.erroSocial, tipo.startsWith('google') ? 'Google' : 'LinkedIn'));
        }
    });

    async function _validarSocial(provedor, credencial) {
        const botao = [...document.querySelectorAll(provedor === 'Google' ? '[data-ent-google]' : '[data-ent-linkedin]')].find(b => b.offsetParent);
        ocupar(botao);
        try {
            await _validarCredencial(provedor, credencial);
        } finally {
            if (!_saindo) {
                ocupar(botao, false);
            }
        }
    }

    async function _validarCredencial(provedor, credencial) {
        const endereco = provedor === 'Google' ? '/Login/GoogleLoginValidate' : '/Login/LinkedinLoginValidate';
        let r;
        try {
            r = await enviarJson(url(endereco), { credential: credencial, returnUrl: _returnUrl() || undefined, timeZone: _fuso() });
        } catch {
            avisarErro(formatar(T.erroSocial, provedor));
            return;
        }
        const metodo = provedor.toLowerCase();
        if (r?.NaoTemCadastro) {
            _socialSemCadastro(r.Redirect, metodo);
            return;
        }
        if (r?.Pessoas?.length) {
            E.modo = 'entrar';
            E.social = { provedor, metodo, credencial, provedorExterno: r.ProvedorExterno };
            E.usuario = r.Usuario || '';
            E.porEmail = true;
            E.pessoa = null;
            E.pessoas = r.Pessoas;
            _desenharContas();
            _ir('contas');
            return;
        }
        if (_ok(r) && r.Redirect) {
            await _concluirLogin(r.Redirect, metodo);
            return;
        }
        // Colaborador cadastrado pelo ID externo fora do site da empresa dele: a mensagem do servidor, como na senha.
        if (r?.Erro === 'ColaboradorNaoAutorizado') {
            registrarEvento('login_erro', { tipo: 'colaboradornaoautorizado' });
            avisarErro(r.Mensagem || formatar(T.erroSocial, provedor));
            return;
        }
        avisarErro(formatar(T.erroSocial, provedor));
    }

    // Várias contas com o e-mail do Google/LinkedIn: o login do v1 com a conta escolhida e o mesmo token do provedor.
    async function _entrarSocialComConta() {
        const dados = new FormData();
        dados.append('ProvedorExterno', E.social.provedorExterno);
        dados.append('Usuario', E.usuario);
        dados.append('TokenProvedorExterno', E.social.credencial);
        dados.append('PessoaID', E.pessoa.ID);
        dados.append('ReturnUrl', _returnUrl());
        dados.append('TimeZone', _fuso());
        let r;
        try {
            r = await enviarFormulario(url('/Login/Autenticar'), dados);
        } catch {
            avisarErro(formatar(T.erroSocial, E.social.provedor));
            return;
        }
        await _tratarLogin(r, E.social.metodo);
    }

    function _socialSemCadastro(redirect, metodo) {
        let q = null;
        try {
            q = new URL(redirect, window.location.origin).searchParams;
        } catch {
            // Sem o endereço do cadastro, sem os dados do provedor.
        }
        const email = q?.get('email') || '';
        if (!email) {
            avisarErro(formatar(T.erroSocial, metodo === 'google' ? 'Google' : 'LinkedIn'));
            return;
        }
        const fotoUrl = q.get('fotoUrl') || '';
        E.cad = { ...E.cad, via: metodo, email, cpf: '', nome: (q.get('nome') || '').trim(), fotoUrl: /^https:\/\//i.test(fotoUrl) ? fotoUrl : '', senha: '', sugVisto: true, criada: false };
        registrarEvento('login_erro', { tipo: 'social_sem_cadastro', metodo });
        _prepararDados();
        _ir(_perguntarTipo() ? 'tipo' : 'dados');
    }

    // ----- cadastro (o "Não encontramos" é o começo dele) -----
    // Pelo e-mail: conta (nome e senha) → dados; pelo Google/LinkedIn: dados com a senha. Um POST só no fim dos dados
    // (PainelCadastrar/CadastrarV2, as regras do cadastro de hoje); com a vaga que pede currículo completo, o passo dele vem
    // antes de voltar.
    const _criterios = id => ($(id) ? ligarCriteriosSenha($(id), { textos: T.criterios, depoisDe: $(id).closest('.ent__senha') }) : null);
    const _critNovo = _criterios('entNovoSenha');
    const _critDados = _criterios('entDadosSenha');
    const _critQuiz = _criterios('entQuizSenha');
    _limparErroDaSenha('entQuizSenha', 'entQuizSenha2', T.quizSenhaDiferente);

    // As regras de cada campo valem no envio e em tempo real (_validarAoVivo).
    const _emailDoNovo = () => (!$('entNovoEmailF').hidden ? $('entNovoEmail').value.trim().toLowerCase() : E.cad.email);
    const REGRAS_NOVO = {
        entNovoEmail: () => (_emailNovoValido(_emailDoNovo()) ? '' : T.erroEmail),
        entNovoNome: () => (_nomeValido(_nomeLimpo($('entNovoNome').value)) ? '' : T.erroNome),
        entNovoSenha: () => (senhaValida($('entNovoSenha').value) ? '' : T.senhaCriterios)
    };
    const _cepDoCadastro = () => E.cad.pais === 'BR' && !E.cad.semCep;
    const _foneDoCadastro = () => _fone({ entCel: _itiCadastro }, 'entCel');
    const _colaborador = () => E.cad.tipo === 'colaborador';
    const _perguntarTipo = () => MODO_ID === 'ambos' && !E.cad.tipo;
    const REGRAS_DADOS = {
        entDadosNome: () => (E.cad.via !== 'email' && !$('entDadosNomeF').hidden && !_nomeValido(_nomeLimpo($('entDadosNome').value)) ? T.erroNome : ''),
        entNasc: () => {
            const idade = _idade($('entNasc').value.trim());
            return idade < 0 ? T.erroNascimento : idade < 14 ? T.idadeMinima : '';
        },
        entCpf: () => (E.cad.pais === 'BR' && !_colaborador() && !_cpfValido($('entCpf').value) ? T.erroCpf : ''),
        entIdExterno: () => _erroIdExterno(),
        entCel: () => _erroDoFone(_foneDoCadastro()),
        entCep: () => (_cepDoCadastro() && _so($('entCep').value).length !== 8 ? T.cvErroCep : ''),
        entCidade: () => (E.cad.pais === 'BR' && (E.cad.semCep || E.cad.cepFalhou) && !E.cad.cidadeID ? T.erroCidade : ''),
        entDadosSenha: () => (E.cad.via !== 'email' && !senhaValida($('entDadosSenha').value) ? T.senhaCriterios : ''),
        entTermos: () => ($('entTermos').checked ? '' : T.erroTermos)
    };

    // Passos do cadastro: pelo e-mail são 2, pelo provedor 1; a vaga que pede currículo completo soma o dele.
    function _totalPassos() {
        return (E.cad.via === 'email' ? 2 : 1) + (_pendencia()?.cv ? 1 : 0);
    }

    function _progresso(passo) {
        const el = cartao.querySelector(`.ent__passo[data-passo="${passo}"] [data-ent-prog]`);
        if (!el) {
            return;
        }
        const total = _totalPassos();
        const n = passo === 'novo' ? 1 : passo === 'dados' ? total - (_pendencia()?.cv ? 1 : 0) : total;
        // O currículo de quem já tinha conta (login) não é passo de cadastro.
        el.hidden = total < 2 || (passo === 'curriculo' && !E.cv.novo);
        if (!el.hidden) {
            const texto = formatar(T.passoDe, n, total);
            el.setAttribute('aria-label', texto);
            el.innerHTML = `<span aria-hidden="true"></span><span class="ent__barras" aria-hidden="true">${'<span class="on"></span>'.repeat(n)}${'<span></span>'.repeat(Math.max(0, total - n))}</span>`;
            el.firstElementChild.textContent = texto;
        }
    }

    function _comecarCadastro({ usuario = '', porEmail = true, empilhar = true } = {}) {
        const email = porEmail ? usuario : '';
        E.cad = { ...E.cad, via: 'email', email, cpf: porEmail ? '' : usuario, nome: '', fotoUrl: '', senha: '', sugVisto: false, criada: false };
        $('entNovoTexto').textContent = usuario ? (porEmail ? T.novoNaoEmail : T.novoNaoCpf) : T.novoTexto;
        _desenharQuemNovo();
        _dicaColaborador();
        _sugestaoNovo(email ? _sugerirEmail(email) : '');
        ['entNovoEmail', 'entNovoNome', 'entNovoSenha'].forEach(id => _mostrarErro(id, ''));
        if (empilhar) {
            _ir(_perguntarTipo() ? 'tipo' : 'novo');
        }
    }

    // ----- colaborador pelo ID externo (hotsite) -----
    // "Ambos": a escolha vale para o resto do cadastro (o link do passo dos dados troca depois).
    function _escolherTipo(tipo) {
        E.cad.tipo = tipo;
        _dicaColaborador();
        if (E.cad.via === 'email') {
            _ir('novo');
            return;
        }
        _prepararDados();
        _ir('dados');
    }

    // O CPF que não achou conta, no modo colaborador: a conta de quem se cadastrou pelo ID externo não guarda o CPF.
    function _dicaColaborador() {
        if ($('entNovoColab')) {
            $('entNovoColab').hidden = !(E.cad.cpf && _colaborador());
        }
    }

    // O CPF é do Brasil; no modo colaborador o ID externo da empresa fica no lugar dele, em qualquer país (como na v1).
    function _mostrarDocumento() {
        $('entCpfF').hidden = E.cad.pais !== 'BR' || _colaborador();
        if ($('entIdExternoF')) {
            $('entIdExternoF').hidden = !_colaborador();
        }
        if ($('entTipoTrocar')) {
            $('entTipoTrocar').textContent = _colaborador() ? T.tipoCandidato : T.tipoColaborador;
        }
    }

    // Obrigatório e no formato da empresa (o regex dela, que o servidor confere de novo).
    function _erroIdExterno() {
        const campo = $('entIdExterno');
        if (!campo || !_colaborador()) {
            return '';
        }
        const valor = campo.value.trim();
        if (!valor) {
            return formatar(T.idExternoVazio, campo.dataset.nome);
        }
        let regra = null;
        try {
            regra = campo.dataset.regex ? new RegExp(campo.dataset.regex) : null;
        } catch {
            // Regex que só o .NET entende: fica a conferência do servidor.
        }
        return regra && !regra.test(valor) ? formatar(T.idExternoInvalido, campo.dataset.nome) : '';
    }

    function _desenharQuemNovo() {
        const temEmail = !!E.cad.email;
        const temCpf = !!E.cad.cpf;
        const quem = $('entNovoQuem');
        quem.hidden = !temEmail && !temCpf;
        quem.querySelector('use').setAttribute('href', temEmail ? '#i-envelope' : '#i-person-badge');
        $('entNovoQuemTexto').textContent = temEmail ? E.cad.email : temCpf ? `CPF ${E.cad.cpf}` : '';
        $('entNovoEmailF').hidden = temEmail;
        $('entNovoEmail').value = temEmail ? E.cad.email : '';
        $('entNovoUsuario').value = E.cad.email;
    }

    function _sugestaoNovo(sugestao) {
        E.cad.sugestao = sugestao;
        $('entNovoSug').hidden = !sugestao;
        if (sugestao) {
            _comDestaque($('entNovoSugTexto'), T.quisDizer, sugestao);
        }
    }


    // O e-mail que veio do primeiro passo vira campo de novo, com o que foi digitado, para a pessoa corrigir.
    function _abrirEmailDoNovo() {
        const digitado = E.cad.email;
        E.cad.email = '';
        _desenharQuemNovo();
        $('entNovoEmail').value = digitado;
    }

    async function _enviarNovo(botao) {
        // Voltou até aqui depois de criar a conta: não confere o e-mail de novo (ele já tem conta, a dela).
        if (E.cad.criada) {
            await _comBotao(botao, () => _depoisDaConta('', { novo: true }));
            return;
        }
        // O e-mail do primeiro passo (o login aceita mais formatos) também segue a regra da conta nova.
        if ($('entNovoEmailF').hidden && !_emailNovoValido(E.cad.email)) {
            _abrirEmailDoNovo();
        }
        const campoEmail = !$('entNovoEmailF').hidden;
        const email = _emailDoNovo();
        const nome = _nomeLimpo($('entNovoNome').value);
        const senha = $('entNovoSenha').value;
        const erros = _errosDe(REGRAS_NOVO);
        if (erros.entNovoSenha) {
            _critNovo?.marcarFaltas();
        }
        if (_mostrarErros(erros)) {
            return;
        }
        if (campoEmail) {
            // O domínio digitado errado ganha a sugestão uma vez; o e-mail que já tem conta vai para a senha dele.
            const sugestao = !E.cad.sugVisto && _sugerirEmail(email);
            if (sugestao) {
                E.cad.sugVisto = true;
                _sugestaoNovo(sugestao);
                $('entNovoSug').querySelector('button').focus();
                return;
            }
            const conta = await _comBotao(botao, async () => {
                try {
                    const r = await _identificar(email);
                    return r?.sucesso ? r : null;
                } catch {
                    return null;
                }
            });
            if (conta) {
                Object.assign(E, { modo: 'entrar', usuario: email, porEmail: true, pessoa: null, social: null, pessoas: conta.pessoas || [] });
                avisar(T.emailJaCadastrado);
                if (E.pessoas.length) {
                    _desenharContas();
                    _ir('contas');
                } else {
                    await _seguirComConta(conta.semSenha);
                }
                return;
            }
            E.cad.email = email;
        }
        E.cad.nome = nome;
        E.cad.senha = senha;
        _prepararDados();
        _ir('dados');
    }

    function _prepararDados() {
        const social = E.cad.via !== 'email';
        $('entDadosQuem').hidden = !social;
        if (social) {
            $('entDadosQuemTexto').textContent = E.cad.email;
            const foto = $('entDadosFoto');
            foto.hidden = !E.cad.fotoUrl;
            if (E.cad.fotoUrl) {
                foto.src = E.cad.fotoUrl;
            }
        }
        // O nome do provedor pode vir sem sobrenome: aí ele aparece para completar.
        $('entDadosNomeF').hidden = !social || _nomeValido(E.cad.nome);
        $('entDadosNome').value = E.cad.nome;
        $('entT-dados').textContent = social ? formatar(T.dadosSocialTitulo, E.cad.nome.split(' ')[0] || '') : T.dadosTitulo;
        $('entDadosTexto').textContent = social ? formatar(T.dadosSocialTexto, E.cad.via === 'google' ? 'Google' : 'LinkedIn') : T.dadosTexto;
        $('entDadosSenhaF').hidden = !social;
        $('entDadosOutro').hidden = !social;
        if (E.cad.cpf && !$('entCpf').value) {
            $('entCpf').value = MASCARAS.cpf(E.cad.cpf);
        }
        _mostrarDocumento();
        _mostrarEndereco();
        const p = _pendencia();
        $('entDadosEnviar').textContent = p?.cv ? T.criarContinuar : p ? T.criarCandidatar : T.criarConta;
        _mostrarErro('dados', '');
        _prepararCamposDados();
    }

    let _bibliotecasDados = null;
    let _itiCadastro = null;
    function _prepararCamposDados() {
        _bibliotecasDados ??= _carregarBibliotecas().then(libs => {
            _itiCadastro = _telefone($('entCel'), libs);
            const pais = obterGeo()?.pais;
            if (pais && pais !== 'BR') {
                try {
                    _itiCadastro.setCountry(pais.toLowerCase());
                } catch {
                    // País que a biblioteca não conhece: fica o Brasil.
                }
            }
        }).catch(() => {
            // Sem a biblioteca, o celular vai como digitado, com o código do Brasil (como o v1).
            _bibliotecasDados = null;
        });
        _cidadeDaConexao();
    }

    // A cidade vem pela conexão (cf-ipcity, guardada pelo GetUsuarioLogado), se ela existir na lista de cidades.
    async function _cidadeDaConexao() {
        if (E.cad.cidadeID || $('entCidade').value) {
            return;
        }
        const geo = obterGeo();
        if (!geo?.cidade || (geo.pais && geo.pais !== 'BR')) {
            return;
        }
        try {
            const r = await obterJson(urlApi(`/variaveis/cidades/buscarV2?query=${encodeURIComponent(geo.cidade)}`));
            const uf = (geo.regiaoCodigo || '').toUpperCase();
            const alvo = _cidadesDaResposta(r).find(c => _semAcento(c.nome).startsWith(`${_semAcento(geo.cidade)},`) && (!uf || c.nome.toUpperCase().includes(`, ${uf}`)));
            if (alvo && !$('entCidade').value) {
                $('entCidade').value = _nomeDaCidade(alvo.nome);
                E.cad.cidadeID = alvo.id;
                $('entH-entCidade').hidden = false;
            }
        } catch {
            // Sem a cidade da conexão, a pessoa digita.
        }
    }

    async function _abrirPais() {
        let paises;
        try {
            paises = await _carregarPaises();
        } catch {
            avisarErro(T.erroServidor);
            return;
        }
        const campo = $('entPais');
        campo.value = paises.find(p => p.id === E.cad.pais)?.nome || '';
        $('entPaisF').hidden = false;
        $('entPaisLinha').hidden = true;
        campo.focus();
        campo.select();
    }

    function _trocarPais(id) {
        const novo = id || 'BR';
        // A cidade da lista (e a da localização, sempre do Brasil) é do país de antes.
        if (novo !== E.cad.pais) {
            $('entCidade').value = '';
            E.cad.cidadeID = 0;
            $('entH-entCidade').hidden = true;
        }
        E.cad.pais = novo;
        _mostrarDocumento();
        ['entPais', 'entCpf', 'entCep', 'entCidade'].forEach(c => _mostrarErro(c, ''));
        _mostrarEndereco();
        try {
            _itiCadastro?.setCountry(E.cad.pais.toLowerCase());
        } catch {
            // País que a biblioteca não conhece: a pessoa escolhe a bandeira.
        }
    }

    // A dica do CEP é lida pelo leitor de tela: só muda quando o texto muda.
    function _dicaCep(texto) {
        if ($('entH-entCep').textContent !== texto) {
            $('entH-entCep').textContent = texto;
        }
    }

    // No Brasil, o CEP; a lista de cidades com "Não sei meu CEP", com o CEP não encontrado e fora do Brasil.
    function _mostrarEndereco() {
        const peloCep = _cepDoCadastro();
        $('entCepF').hidden = !peloCep;
        $('entSemCep').hidden = !peloCep || E.cad.cepFalhou;
        $('entCidadeF').hidden = peloCep && !E.cad.cepFalhou;
        $('entComCep').hidden = E.cad.pais !== 'BR' || peloCep;
    }

    // A busca do CEP traz a cidade, o estado, a rua e o bairro, que entram com a conta. Devolve a busca em andamento, para o
    // envio esperar por ela.
    let _cepBusca = null;
    function _buscarCepCadastro() {
        const cep = _so($('entCep').value);
        if (cep.length !== 8) {
            return Promise.resolve();
        }
        if (cep === E.cad.cep.buscado) {
            return _cepBusca || Promise.resolve();
        }
        E.cad.cep = { buscado: cep, cidadeID: 0, logradouro: '', bairro: '' };
        // CEP fora da base vai à BrasilAPI e ao ViaCEP: sem resposta em 8 s, a lista de cidades.
        const controle = new AbortController();
        const prazo = setTimeout(() => controle.abort(), 8000);
        const esta = obterJson(url(`/Home/BuscarCep?cep=${cep}`), { sinal: controle.signal }).then(r => ({ r }), () => ({ falhou: true })).then(({ r, falhou }) => {
            clearTimeout(prazo);
            // Outra busca começou depois desta (o CEP mudou ou foi redigitado): esta resposta não vale mais.
            if (_cepBusca !== esta) {
                return;
            }
            E.cad.cepFalhou = !!falhou || !r || !!r.erro || !r.cidadeID;
            if (!E.cad.cepFalhou) {
                Object.assign(E.cad.cep, { cidadeID: r.cidadeID, logradouro: r.logradouro || '', bairro: r.bairro || '' });
            } else if (falhou) {
                // Falha de rede não é CEP inexistente: o envio busca de novo.
                E.cad.cep.buscado = '';
            }
            _dicaCep(falhou ? T.cvCepDica : E.cad.cepFalhou ? T.cepNaoEncontradoCidade : [r.localidade, r.uf].filter(Boolean).join(', '));
            _mostrarErro('entCep', '');
            _mostrarEndereco();
        });
        _cepBusca = esta;
        return esta;
    }

    // O CPF que já tem conta (ou conta desativada) sai antes do fim, como no cadastro de hoje (VerificarCpf).
    async function _conferirCpf() {
        const cpf = $('entCpf').value;
        if (E.cad.pais !== 'BR' || _colaborador() || !_cpfValido(cpf)) {
            return;
        }
        try {
            const r = await obterJson(url(`/PainelCadastrar/VerificarCpf?cpf=${encodeURIComponent(cpf)}`), { semCache: true });
            if (r?.metodo === 'UsuarioJaCadastrado' || r?.metodo === 'IncluirNoArquivoDaEmpresa') {
                _cpfComConta(cpf, false);
            } else if (r?.metodo === 'CadastroBloqueado') {
                _cpfComConta(cpf, true);
            }
        } catch {
            // O envio confere de novo.
        }
    }

    function _cpfComConta(cpf, desativado) {
        if (_passo !== 'dados') {
            return;
        }
        E.cad.cpfConta = cpf;
        $('entT-cpfExiste').textContent = desativado ? T.bloqueadoTitulo : T.cpfExisteTitulo;
        if (desativado) {
            $('entCpfExisteTexto').textContent = T.bloqueadoTexto;
        } else {
            _comDestaque($('entCpfExisteTexto'), T.cpfExisteTexto, cpf);
        }
        cartao.querySelector('[data-ent-cpf-entrar]').textContent = T.entrarComCpf;
        _ir('cpfExiste');
    }

    async function _enviarDados(botao) {
        const social = E.cad.via !== 'email';
        const brasil = E.cad.pais === 'BR';
        if (social && !$('entDadosNomeF').hidden) {
            E.cad.nome = _nomeLimpo($('entDadosNome').value);
        }
        await _comBotao(botao, async () => {
            // O CEP digitado e ainda não buscado (ou com a busca a caminho) decide a cidade antes de conferir; mudou na espera, a
            // busca é refeita.
            for (let i = 0; i < 3 && _cepDoCadastro() && _so($('entCep').value).length === 8; i++) {
                await _buscarCepCadastro();
                if (E.cad.cepFalhou || E.cad.cep.buscado === _so($('entCep').value)) {
                    break;
                }
            }
            // Voltou um passo durante a espera: não envia.
            if (_passo !== 'dados') {
                return;
            }
            const nascimento = $('entNasc').value.trim();
            const colaborador = _colaborador();
            const cpf = colaborador ? '' : $('entCpf').value.trim();
            const cel = _foneDoCadastro();
            const senha = social ? $('entDadosSenha').value : E.cad.senha;
            const erros = _errosDe(REGRAS_DADOS);
            if (!erros.entCep && _cepDoCadastro() && !E.cad.cepFalhou && !E.cad.cep.cidadeID) {
                erros.entCep = T.cepNaoEncontradoCidade;
            }
            if (erros.entDadosSenha) {
                _critDados?.marcarFaltas();
            }
            _mostrarErro('dados', '');
            if (_mostrarErros(erros)) {
                return;
            }
            // Voltou depois de criar a conta: não cria outra.
            if (E.cad.criada) {
                await _depoisDaConta('', { novo: true });
                return;
            }
            const p = _pendencia();
            // A cidade é a do CEP achado; com o CEP não encontrado, sem ele ou fora do Brasil, a da lista.
            const peloCep = _cepDoCadastro() && !E.cad.cepFalhou;
            const cidadeID = peloCep ? E.cad.cep.cidadeID : E.cad.cidadeID;
            const dados = new FormData();
            dados.append('nome', E.cad.nome);
            dados.append('email', E.cad.email);
            dados.append('senha', senha);
            dados.append('nascimento', nascimento);
            dados.append('paisID', E.cad.pais);
            dados.append('cpf', brasil ? cpf : '');
            dados.append('celular', cel.valor);
            dados.append('celularPaisCode', `+${cel.ddi}`);
            dados.append('cidadeID', cidadeID ? String(cidadeID) : '');
            // Só o CEP achado: o não encontrado pode ter sido digitado errado.
            dados.append('cep', peloCep ? MASCARAS.cep($('entCep').value) : '');
            dados.append('logradouro', peloCep ? E.cad.cep.logradouro : '');
            dados.append('bairro', peloCep ? E.cad.cep.bairro : '');
            dados.append('termosUso', 'true');
            dados.append('vagaID', _vagaDaVolta() || '0');
            dados.append('fotoUrl', E.cad.fotoUrl);
            dados.append('timeZone', _fuso());
            dados.append('returnUrl', _returnUrl());
            dados.append('provedor', social ? E.cad.via : '');
            if (colaborador) {
                dados.append('idExterno', $('entIdExterno').value.trim());
            }
            let r;
            try {
                r = await enviarFormulario(url('/PainelCadastrar/CadastrarV2'), dados);
            } catch {
                _mostrarErro('dados', T.erroServidor);
                return;
            }
            if (r?.sucesso) {
                E.cad.criada = true;
                registrarEvento('cadastro_concluido', { metodo: E.cad.via });
                registrarConversaoCadastro();
                avisarLogin('login');
                try {
                    sessionStorage.setItem('v2-conta-nova', E.cad.email);
                } catch {
                    // O quadro de enviada só não diz que a conta foi criada.
                }
                await _depoisDaConta(r.url, { novo: true });
                return;
            }
            if (r?.metodo === 'UsuarioJaCadastrado' || r?.metodo === 'IncluirNoArquivoDaEmpresa' || r?.metodo === 'CadastroBloqueado') {
                if (brasil && cpf) {
                    _cpfComConta(cpf, r.metodo === 'CadastroBloqueado');
                } else if (colaborador) {
                    // O ID externo já tem conta, que entra pelo e-mail dela (não necessariamente este); desativada, o aviso da conta desativada.
                    avisar(r.metodo === 'CadastroBloqueado' ? T.bloqueadoTexto : formatar(T.idExternoComConta, $('entIdExterno').dataset.nome));
                    E.modo = 'entrar';
                    _voltarPara('entrar', () => {
                        const campo = $(FORMULARIO.entrar);
                        campo.value = '';
                        campo.focus();
                    });
                } else {
                    // Fora do Brasil a conta é pelo e-mail: entra com ele.
                    avisar(T.emailJaCadastrado);
                    E.modo = 'entrar';
                    _voltarPara('entrar', () => { $(FORMULARIO.entrar).value = E.cad.email; });
                }
                return;
            }
            if (r?.metodo === 'IdExternoInvalido') {
                _mostrarErros({ entIdExterno: formatar(T.idExternoInvalido, $('entIdExterno').dataset.nome) });
                return;
            }
            if (r?.metodo === 'CpfInvalido') {
                // O servidor não pediu o ID externo (página da borda de antes de a empresa mudar o cadastro): o CPF volta.
                if (colaborador) {
                    E.cad.tipo = 'candidato';
                    _mostrarDocumento();
                }
                _mostrarErros({ entCpf: T.erroCpf });
                return;
            }
            // Senha, nome e e-mail do cadastro pelo e-mail ficam no 1º passo: volta a ele, com o campo marcado.
            if (!social && ['senha', 'nome', 'email'].includes(r?.campo)) {
                _voltarPara('novo', () => {
                    if (r.campo === 'email' && $('entNovoEmailF').hidden) {
                        _abrirEmailDoNovo();
                    }
                    const id = { senha: 'entNovoSenha', nome: 'entNovoNome', email: 'entNovoEmail' }[r.campo];
                    _mostrarErros({ [id]: r.campo === 'nome' ? T.erroNome : r.mensagem || T.erroEmail });
                });
                return;
            }
            if (social && r?.campo === 'nome') {
                $('entDadosNomeF').hidden = false;
                $('entDadosNome').value = E.cad.nome;
            }
            const campo = { termos: 'entTermos', senha: 'entDadosSenha', nome: 'entDadosNome', nascimento: 'entNasc', pais: 'entPais', celular: 'entCel', cidade: peloCep ? 'entCep' : 'entCidade', idExterno: 'entIdExterno' }[r?.campo];
            if (campo && $(campo)) {
                _mostrarErros({ [campo]: r.mensagem });
                return;
            }
            _mostrarErro('dados', r?.mensagem || T.erroServidor);
        }, { congelar: $('entFormDados') });
    }

    // Conta pronta (cadastro ou login) com a vaga do "Candidate-se": o currículo completo, quando ela pede, vem antes de voltar.
    async function _depoisDaConta(destino, { novo = false } = {}) {
        const volta = _volta();
        if (!volta) {
            _sairPara(destino || url('/candidato/painel'));
            return;
        }
        const vagaID = _vagaDaVolta();
        if (vagaID && await _precisaCurriculo(vagaID)) {
            await _irCurriculo({ novo });
            return;
        }
        _sairPara(volta.url);
    }

    async function _precisaCurriculo(vagaID) {
        try {
            const r = await obterJson(url(`/Vagas/BotaoCandidatar/${encodeURIComponent(vagaID)}`), { semCache: true });
            return r?.retorno === 'CurriculoIncompleto';
        } catch {
            return false;
        }
    }

    // ----- currículo completo (a maioria das vagas pede) -----
    // Só o que a regra confere (proc_CurriculoProgresso) e ainda falta. As gravações são as do editor de hoje: endereço e
    // celular pelo "concluir cadastro" (SalvarDadosFaltantes), formação e experiência (SaveFormacao,
    // SaveExperiencia). O arquivo vai para a leitura por IA de hoje (UploadCurriculo), que grava o que encontrar.
    // endereco: o que a conta já tem (país, cidade, CEP, rua e bairro), para o passo não pedir de novo.
    async function _progressoDoCurriculo({ endereco = false } = {}) {
        try {
            const r = await obterJson(url(`/PainelCurriculoAntigo/GetProgresso${endereco ? '?endereco=true' : ''}`), { semCache: true });
            return r?.sucesso ? r : null;
        } catch {
            return null;
        }
    }

    function _voltarParaVaga() {
        _sairPara(_volta()?.url || _returnUrl() || url('/candidato/painel'));
    }

    // substituir: aberto direto (?curriculo=), o passo toma o lugar do "Entrar" no histórico (o Voltar leva à vaga).
    async function _irCurriculo({ novo = false, substituir = false } = {}) {
        E.cv.novo = novo;
        const r = await _progressoDoCurriculo({ endereco: true });
        if (!r) {
            // Sem saber o que falta, voltar à vaga a traria de novo para cá: o erro fica na tela.
            avisarErro(T.erroServidor);
            return false;
        }
        if (!r.incompleto) {
            // O F5 no resumo (ou no "Adicionar") volta ao resumo: a candidatura só sai pelo "Enviar candidatura".
            if (new URLSearchParams(window.location.search).has('cvResumo')) {
                E.cv.progresso = r.progresso;
                _ir('curriculo', { substituir });
                _mostrarResumoCv();
                return true;
            }
            _voltarParaVaga();
            return true;
        }
        E.cv.progresso = r.progresso;
        E.cv.endereco = r.endereco || null;
        _desenharCurriculo();
        _ir('curriculo', { substituir });
        // O F5 neste passo volta a ele (o endereço diz a vaga).
        const vagaID = _vagaDaVolta();
        if (vagaID) {
            const q = new URLSearchParams(window.location.search);
            q.set('curriculo', vagaID);
            history.replaceState(history.state, '', `${window.location.pathname}?${q}`);
        }
        return true;
    }

    function _faltasDoCurriculo(pr) {
        const tem = nome => !!_prop(pr, nome);
        return {
            endereco: !tem('Cep') || !tem('Logradouro') || !tem('Cidade'),
            telefone: !tem('Telefone'),
            formacao: !tem('Formacao'),
            experiencia: !tem('Experiencia') && !tem('SemExperiencia')
        };
    }

    // As partes do formulário: o que falta ou, com o currículo completo, a experiência ou a formação a mais que a pessoa abriu.
    function _secoesCv() {
        return E.cv.extra ? { endereco: false, telefone: false, formacao: E.cv.extra === 'formacao', experiencia: E.cv.extra === 'experiencia' } : _faltasDoCurriculo(E.cv.progresso);
    }

    let _camposCvProntos = false;
    let _itiCv = null;
    function _desenharCurriculo() {
        const p = _pendencia();
        const empresa = p && !p.conf && p.empresa ? p.empresa : T.cvEmpresa;
        const { resumo, extra } = E.cv;
        $('entT-curriculo').textContent = resumo ? T.cvProntoTitulo : extra === 'formacao' ? T.cvAddFormacao : extra ? T.cvAddExperiencia : E.cv.novo ? T.cvTitulo : T.cvTituloLogado;
        $('entCvTexto').textContent = resumo ? T.cvProntoTexto : formatar(E.cv.novo ? T.cvTextoNovo : T.cvTexto, empresa);
        $('entCvTexto').hidden = !!extra;
        const faltas = _secoesCv();
        $$('#entFormCv [data-cv]').forEach(secao => { secao.hidden = !faltas[secao.dataset.cv]; });
        $('entCvOu').hidden = resumo || !!extra || !Object.values(faltas).some(Boolean);
        $('entCvFeitos').hidden = !resumo;
        $('entFormCv').hidden = resumo;
        // O arquivo é só da 1ª vez: depois, a pessoa acrescenta item a item.
        if (resumo || extra) {
            ['entCvArquivo', 'entCvLendo', 'entCvLido'].forEach(id => { $(id).hidden = true; });
            _mostrarErro('cvArquivo', '');
        }
        // No "Adicionar", o título já diz a parte: as legendas ficam só para o leitor de tela.
        $$('#entFormCv [data-cv] > legend').forEach(l => l.classList.toggle('sr', !!extra));
        const legenda = cartao.querySelector('[data-cv="experiencia"] legend');
        legenda.dataset.original ??= legenda.textContent;
        legenda.textContent = extra ? T.cvOutraExperiencia : legenda.dataset.original;
        cartao.querySelector('label[for="entCvSemExp"]').hidden = !!extra;
        // Só quando muda: o redesenho no meio do envio apagaria a roda do botão ocupado.
        const rotulo = extra ? T.cvSalvarItem : T.cvSalvarContinuar;
        if ($('entCvEnviar').dataset.rotulo !== rotulo) {
            $('entCvEnviar').dataset.rotulo = rotulo;
            $('entCvEnviar').textContent = rotulo;
        }
        $('entCvCancelar').hidden = !extra;
        _mostrarErro('cv', '');
        // O que a conta já tem do endereço entra preenchido (uma vez: o passo é redesenhado depois de cada gravação). Fora do
        // Brasil o código postal é livre, sem a busca do CEP, e a cidade vem da lista.
        if (faltas.endereco && !E.cv.preenchido) {
            E.cv.preenchido = true;
            const en = E.cv.endereco || {};
            E.cv.pais = en.pais || 'BR';
            E.cv.cidadeID = en.cidadeID || 0;
            E.cv.estadoID = en.estadoID || null;
            $('entCvCep').value = en.cep || '';
            $('entCvLogradouro').value = en.logradouro || '';
            $('entCvBairro').value = en.bairro || '';
            $('entCvCidade').value = en.cidade || '';
            if (E.cv.pais !== 'BR') {
                cartao.querySelector('label[for="entCvCep"]').textContent = T.cvCodigoPostal;
                Object.assign($('entCvCep'), { inputMode: 'text', placeholder: '', maxLength: 20 });
                $('entH-entCvCep').hidden = true;
                $('entCvCidadeF').hidden = false;
            }
        }
        if (faltas.telefone && !_itiCv) {
            _carregarBibliotecas().then(libs => { _itiCv = _telefone($('entCvCel'), libs); }).catch(() => { /* o celular vai como digitado */ });
        }
        if (!_camposCvProntos) {
            _camposCvProntos = true;
            // Fora do Brasil, o código postal livre (sem a máscara de 8 números).
            if (E.cv.pais === 'BR') {
                _mascarar($('entCvCep'), 'cep');
            }
            $$('#entFormCv [data-ent-mes]').forEach(c => _mascarar(c, 'mes'));
            $('entCvCep').addEventListener('input', () => { if (_so($('entCvCep').value).length === 8) { _buscarCep(); } });
            _listaDeCidades($('entCvCidade'), $('entCvCidadeLista'), c => {
                E.cv.cidadeID = c ? c.id : 0;
                E.cv.estadoID = null;
                if (c) {
                    _mostrarErro('entCvCidade', '');
                }
            });
            $('entCvGrau').addEventListener('change', _ajustarFormacao);
            $('entCvSemExp').addEventListener('change', () => { $('entCvExpCampos').hidden = $('entCvSemExp').checked; });
            $('entCvAtual').addEventListener('change', () => { $('entCvExpFimF').hidden = $('entCvAtual').checked; });
            _ajustarFormacao();
        }
    }

    // As regras do editor de hoje (formacoes.js): no ensino fundamental, curso, instituição e datas vão preenchidos; no médio,
    // o curso.
    const GRAU_FUNDAMENTAL = ['13', '16'];
    const GRAU_MEDIO = ['17', '1'];
    function _ajustarFormacao() {
        const grau = $('entCvGrau').value;
        const fundamental = GRAU_FUNDAMENTAL.includes(grau);
        cartao.querySelector('[data-cv-grau="instituicao"]').hidden = fundamental;
        cartao.querySelector('[data-cv-grau="curso"]').hidden = fundamental || GRAU_MEDIO.includes(grau);
        cartao.querySelector('[data-cv-grau="datas"]').hidden = fundamental;
    }

    async function _buscarCep() {
        const cep = _so($('entCvCep').value);
        if (E.cv.pais !== 'BR' || cep.length !== 8 || cep === E.cv.cepBuscado) {
            return;
        }
        E.cv.cepBuscado = cep;
        let r = null;
        try {
            r = await obterJson(url(`/Home/BuscarCep?cep=${cep}`));
        } catch {
            r = null;
        }
        const dica = $('entH-entCvCep');
        if (!r || r.erro || !r.cidadeID) {
            E.cv.cidadeID = 0;
            E.cv.estadoID = null;
            dica.textContent = T.cvCepNaoEncontrado;
            $('entCvCidadeF').hidden = false;
            return;
        }
        E.cv.cidadeID = r.cidadeID;
        E.cv.estadoID = r.estadoID;
        dica.textContent = [r.localidade, r.uf].filter(Boolean).join(', ');
        $('entCvCidadeF').hidden = true;
        _mostrarErro('entCvCep', '');
        if (r.bairro && !$('entCvBairro').value) {
            $('entCvBairro').value = r.bairro;
        }
        if (r.logradouro && !$('entCvLogradouro').value) {
            // O número a pessoa completa (o logradouro do CEP vem sem ele).
            $('entCvLogradouro').value = `${r.logradouro}, `;
            $('entCvLogradouro').focus();
        }
    }

    function _mesAno(valor) {
        const m = /^(\d{2})\/(\d{4})$/.exec(valor || '');
        if (!m || +m[1] < 1 || +m[1] > 12 || +m[2] < 1900 || +m[2] > new Date().getFullYear() + 10) {
            return null;
        }
        return { mes: +m[1], ano: +m[2], valor: +m[2] * 12 + +m[1] };
    }

    function _validarCurriculo(faltas) {
        const erros = {};
        if (faltas.endereco) {
            const brasil = E.cv.pais === 'BR';
            erros.entCvCep = brasil ? (_so($('entCvCep').value).length === 8 ? '' : T.cvErroCep) : ($('entCvCep').value.trim() ? '' : T.cvErroCodigoPostal);
            erros.entCvLogradouro = $('entCvLogradouro').value.replace(/[\s,]+$/, '').trim() ? '' : T.cvErroLogradouro;
            // O bairro só no Brasil (a regra do currículo completo não o confere).
            erros.entCvBairro = !brasil || $('entCvBairro').value.trim() ? '' : T.cvErroBairro;
            if (!erros.entCvCep && !E.cv.cidadeID) {
                erros[$('entCvCidadeF').hidden ? 'entCvCep' : 'entCvCidade'] = $('entCvCidadeF').hidden ? T.cvCepNaoEncontrado : T.erroCidade;
            }
        }
        if (faltas.telefone) {
            erros.entCvCel = _erroDoFone(_fone({ entCvCel: _itiCv }, 'entCvCel'));
        }
        if (faltas.formacao) {
            const grau = $('entCvGrau').value;
            const fundamental = GRAU_FUNDAMENTAL.includes(grau);
            erros.entCvGrau = grau ? '' : T.cvErroGrau;
            if (grau && !fundamental) {
                erros.entCvInst = $('entCvInst').value.trim() ? '' : T.cvErroInstituicao;
                if (!GRAU_MEDIO.includes(grau)) {
                    erros.entCvCurso = $('entCvCurso').value.trim() ? '' : T.cvErroCurso;
                }
                const ini = _mesAno($('entCvFormIni').value);
                const fim = _mesAno($('entCvFormFim').value);
                erros.entCvFormIni = ini ? '' : T.cvErroData;
                erros.entCvFormFim = !fim ? T.cvErroData : ini && fim.valor < ini.valor ? T.cvErroDataOrdem : '';
            }
        }
        if (faltas.experiencia && !$('entCvSemExp').checked) {
            erros.entCvCargo = $('entCvCargo').value.trim() ? '' : T.cvErroCargo;
            erros.entCvEmpresa = $('entCvEmpresa').value.trim() ? '' : T.cvErroEmpresa;
            erros.entCvExpCidade = $('entCvExpCidade').value.trim() ? '' : T.cvErroExpCidade;
            const ini = _mesAno($('entCvExpIni').value);
            erros.entCvExpIni = ini ? '' : T.cvErroData;
            if (!$('entCvAtual').checked) {
                const fim = _mesAno($('entCvExpFim').value);
                erros.entCvExpFim = !fim ? T.cvErroData : ini && fim.valor < ini.valor ? T.cvErroDataOrdem : '';
            }
            erros.entCvAtividades = $('entCvAtividades').value.trim() ? '' : T.cvErroAtividades;
        }
        return erros;
    }

    async function _gravarCurriculo(faltas) {
        if (faltas.endereco || faltas.telefone) {
            const pessoa = {};
            const dadosFaltantes = {};
            if (faltas.endereco) {
                const brasil = E.cv.pais === 'BR';
                Object.assign(pessoa, { PaisID: E.cv.pais, EstadoID: E.cv.estadoID || 0, CidadeID: E.cv.cidadeID, Cep: brasil ? MASCARAS.cep($('entCvCep').value) : $('entCvCep').value.trim(), Bairro: $('entCvBairro').value.trim(), Logradouro: $('entCvLogradouro').value.replace(/[\s,]+$/, '').trim() });
                dadosFaltantes.EnderecoNaoPreenchido = true;
            }
            if (faltas.telefone) {
                const ddi = _itiCv?.getSelectedCountryData()?.dialCode || '55';
                Object.assign(pessoa, { Celular: $('entCvCel').value.trim(), CelularPaisCode: `+${ddi}` });
                dadosFaltantes.CelularNaoPreenchido = true;
            }
            const r = await enviarJson(url('/PainelNotificacoes/SalvarDadosFaltantes'), { pessoa, dadosFaltantes });
            if (!r?.sucesso) {
                return r?.mensagem || T.erroServidor;
            }
        }
        if (faltas.formacao) {
            const grau = $('entCvGrau').value;
            const fundamental = GRAU_FUNDAMENTAL.includes(grau);
            const ini = fundamental ? { mes: 1, ano: 1931 } : _mesAno($('entCvFormIni').value);
            const fim = fundamental ? { mes: 1, ano: 1932 } : _mesAno($('entCvFormFim').value);
            const dados = new FormData();
            dados.append('ID', '0');
            dados.append('GrauID', grau);
            dados.append('Local', fundamental ? 'Ensino Fundamental' : $('entCvInst').value.trim());
            dados.append('Curso', fundamental ? 'Ensino Fundamental' : GRAU_MEDIO.includes(grau) ? 'Ensino Médio' : $('entCvCurso').value.trim());
            dados.append('MesInicio', String(ini.mes));
            dados.append('AnoInicio', String(ini.ano));
            dados.append('MesFim', String(fim.mes));
            dados.append('AnoFim', String(fim.ano));
            dados.append('Incompleto', 'false');
            const r = await enviarFormulario(url('/PainelCurriculoAntigo/SaveFormacao'), dados);
            if (r?.success !== 1) {
                return r?.error || T.erroServidor;
            }
        }
        if (faltas.experiencia) {
            const dados = new FormData();
            if ($('entCvSemExp').checked) {
                dados.append('remover', '1');
            } else {
                const ini = _mesAno($('entCvExpIni').value);
                const atual = $('entCvAtual').checked;
                const fim = atual ? null : _mesAno($('entCvExpFim').value);
                dados.append('ID', '0');
                dados.append('Cargo', $('entCvCargo').value.trim());
                dados.append('Empresa', $('entCvEmpresa').value.trim());
                dados.append('Cidade', $('entCvExpCidade').value.trim());
                dados.append('Descricao', $('entCvAtividades').value.trim());
                dados.append('Resultado', '');
                dados.append('Voluntario', 'false');
                dados.append('PausaCarreira', 'false');
                dados.append('Atual', String(atual));
                dados.append('mesInicio', String(ini.mes));
                dados.append('anoInicio', String(ini.ano));
                if (fim) {
                    dados.append('mesFim', String(fim.mes));
                    dados.append('anoFim', String(fim.ano));
                }
            }
            const r = await enviarFormulario(url('/PainelCurriculoAntigo/SaveExperiencia'), dados);
            if (r?.success !== 1) {
                return r?.error || T.erroServidor;
            }
        }
        return '';
    }

    // Uma experiência ou formação a mais: os campos voltam vazios (a gravação vai sempre como item novo, ID 0).
    function _limparCv(tipo) {
        const ids = tipo === 'formacao' ? ['entCvGrau', 'entCvInst', 'entCvCurso', 'entCvFormIni', 'entCvFormFim']
            : ['entCvCargo', 'entCvEmpresa', 'entCvExpCidade', 'entCvExpIni', 'entCvExpFim', 'entCvAtividades'];
        ids.forEach(id => { $(id).value = ''; _mostrarErro(id, ''); });
        // Só zera os "mexidos" da validação ao vivo (campos.js): sem isso, sair do campo vazio daria erro de cara.
        $('entFormCv').dispatchEvent(new Event('reset'));
        if (tipo === 'formacao') {
            _ajustarFormacao();
        } else {
            $('entCvAtual').checked = false;
            $('entCvSemExp').checked = false;
            $('entCvExpFimF').hidden = false;
            $('entCvExpCampos').hidden = false;
        }
    }

    function _abrirExtraCv(tipo) {
        E.cv.resumo = false;
        E.cv.extra = tipo;
        _limparCv(tipo);
        _desenharCurriculo();
        // O título novo ("Adicionar experiência") é o que o leitor de tela anuncia; no celular, sem abrir o teclado de cara.
        $('entT-curriculo').focus();
    }

    function _listarCv(lista, itens, vazio) {
        lista.replaceChildren(...(itens.length ? itens : [[vazio, '']]).map(([titulo, detalhe]) => {
            const li = document.createElement('li');
            const b = document.createElement('b');
            b.textContent = titulo;
            li.append(b);
            if (detalhe) {
                const small = document.createElement('small');
                small.textContent = detalhe;
                li.append(small);
            }
            li.classList.toggle('is-vazio', !itens.length);
            return li;
        }));
    }

    // O currículo completo: o que ele já tem e a chance de acrescentar mais antes de voltar à vaga. Sem a lista (falha), ficam
    // os botões. voltarA: o "Adicionar" que abriu o formulário cancelado recebe o foco de volta.
    async function _mostrarResumoCv({ voltarA = null } = {}) {
        E.cv.resumo = true;
        E.cv.extra = null;
        _desenharCurriculo();
        (voltarA ? cartao.querySelector(`[data-ent-cv-mais="${voltarA}"]`) : $('entT-curriculo'))?.focus();
        // O F5 a partir daqui volta ao resumo, sem enviar a candidatura (_irCurriculo).
        const q = new URLSearchParams(window.location.search);
        if (!q.has('cvResumo')) {
            q.set('cvResumo', '1');
            history.replaceState(history.state, '', `${window.location.pathname}?${q}`);
        }
        const feitos = $('entCvFeitos');
        feitos.setAttribute('aria-busy', 'true');
        const [exp, form] = await Promise.all([
            obterJson(url('/PainelCurriculoAntigo/GetExperiencias'), { semCache: true }).catch(() => null),
            obterJson(url('/PainelCurriculoAntigo/GetFormacoes'), { semCache: true }).catch(() => null)
        ]);
        feitos.removeAttribute('aria-busy');
        const sem = (titulo, ...partes) => [titulo, partes.filter(x => x && x !== titulo).join(' · ')];
        const temExp = Array.isArray(exp?.experiencias);
        $('entCvListaExp').hidden = $('entCvListaExpT').hidden = !temExp;
        _listarCv($('entCvListaExp'), (exp?.experiencias || []).filter(x => !x.pausaCarreira).map(x => sem(x.cargo, x.empresa, x.periodoPorExtenso)), T.cvNenhumaExperiencia);
        // Fundamental e médio gravam o curso em português (_gravarCurriculo): o título é o grau, que vem traduzido.
        const grauFixo = x => GRAU_FUNDAMENTAL.includes(String(x.grauID)) || GRAU_MEDIO.includes(String(x.grauID));
        $('entCvListaForm').hidden = $('entCvListaFormT').hidden = !Array.isArray(form);
        _listarCv($('entCvListaForm'), (Array.isArray(form) ? form : []).map(x => sem(grauFixo(x) ? x.grau : x.curso || x.grau, x.grau, GRAU_FUNDAMENTAL.includes(String(x.grauID)) ? '' : x.local)), T.cvNenhumaFormacao);
    }

    async function _enviarCurriculo(botao) {
        const faltas = _secoesCv();
        _mostrarErro('cv', '');
        if (_mostrarErros(_validarCurriculo(faltas))) {
            return;
        }
        await _comBotao(botao, async () => {
            let erro;
            try {
                erro = await _gravarCurriculo(faltas);
            } catch {
                erro = T.erroServidor;
            }
            if (E.cv.extra) {
                if (erro) {
                    _mostrarErro('cv', erro);
                    return;
                }
                avisarSucesso(T.cvItemSalvo);
                // Sem esperar a lista: o botão solta logo e o próximo "Adicionar" não fica preso no envio.
                _mostrarResumoCv();
                return;
            }
            // O que gravou não volta a aparecer; quem decide se acabou é a regra do servidor, que se contenta com uma
            // experiência e uma formação: antes de voltar à vaga, o resumo deixa acrescentar as outras.
            const r = await _progressoDoCurriculo();
            if (r && !r.incompleto) {
                registrarEvento('cadastro_passo', { passo: 'curriculo_completo', metodo: E.cad.via });
                _mostrarResumoCv();
                return;
            }
            if (r) {
                E.cv.progresso = r.progresso;
                _desenharCurriculo();
            }
            _mostrarErro('cv', erro || T.cvAindaFalta);
        }, { congelar: $('entFormCv') });
    }

    // O arquivo do currículo: a leitura por IA de hoje (UploadCurriculo + StatusUploadCurriculo, a cada 3 s como o editor).
    function _estadoDoArquivo(estado, nome = '') {
        $('entCvArquivo').hidden = estado !== 'inicio';
        $('entCvLendo').hidden = estado !== 'lendo';
        $('entCvLido').hidden = estado !== 'lido';
        if (estado === 'lendo') {
            $('entCvLendoTitulo').textContent = formatar(T.cvLendo, nome);
        }
    }

    async function _enviarArquivoDoCurriculo(arquivo) {
        _mostrarErro('cvArquivo', '');
        const extensao = (arquivo.name.split('.').pop() || '').toLowerCase();
        if (!['pdf', 'docx', 'jpg', 'jpeg', 'png', 'bmp'].includes(extensao)) {
            _mostrarErro('cvArquivo', T.cvErroTipo);
            return;
        }
        if (arquivo.size > 10000000) {
            _mostrarErro('cvArquivo', T.cvErroTamanho);
            return;
        }
        _estadoDoArquivo('lendo', arquivo.name);
        const dados = new FormData();
        dados.append('uploadfile', arquivo);
        let r = null;
        try {
            r = await enviarFormulario(url('/PainelCurriculoAntigo/UploadCurriculo'), dados);
        } catch {
            r = null;
        }
        if (!r?.sucesso) {
            _estadoDoArquivo('inicio');
            _mostrarErro('cvArquivo', r?.mensagem || T.cvErroArquivo);
            return;
        }
        registrarEvento('cadastro_passo', { passo: 'curriculo_arquivo', metodo: E.cad.via });
        // Até 2 min (o editor espera 3): passou disso, a pessoa responde e a leitura entra depois no currículo.
        for (let i = 0; i < 40; i++) {
            await new Promise(fim => setTimeout(fim, 3000));
            if (_passo !== 'curriculo') {
                return;
            }
            let status = null;
            try {
                status = await obterJson(url('/PainelCurriculoAntigo/StatusUploadCurriculo'), { semCache: true });
            } catch {
                continue;
            }
            if (status?.status === 'concluido') {
                const progresso = await _progressoDoCurriculo();
                // Completo (pela leitura ou à mão enquanto ela corria): o resumo mostra o que a IA leu. No "Adicionar", não atrapalha.
                if (progresso && !progresso.incompleto) {
                    if (!E.cv.extra) {
                        _mostrarResumoCv();
                    }
                    return;
                }
                if (E.cv.resumo || E.cv.extra) {
                    return;
                }
                if (progresso) {
                    E.cv.progresso = progresso.progresso;
                    _desenharCurriculo();
                }
                $('entCvLidoTexto').textContent = progresso && !progresso.incompleto ? T.cvLidoCompleto : T.cvLidoTexto;
                _estadoDoArquivo('lido');
                return;
            }
            if (status?.status === 'erro') {
                if (E.cv.resumo || E.cv.extra) {
                    return;
                }
                _estadoDoArquivo('inicio');
                // A mensagem da leitura diz o porquê (mais de 3 páginas, arquivo sem texto).
                _mostrarErro('cvArquivo', status.mensagem || T.cvErroArquivo);
                return;
            }
        }
        _estadoDoArquivo('inicio');
        _mostrarErro('cvArquivo', T.cvDemorou);
    }

    _mascarar($('entNasc'), 'data');
    _mascarar($('entCpf'), 'cpf');
    _mascarar($('entCep'), 'cep');
    $('entCpf').addEventListener('blur', _conferirCpf);
    $('entCep').addEventListener('input', () => {
        const cep = _so($('entCep').value);
        // Outro CEP: a cidade do anterior não vale mais (a lista some até a busca nova dizer se este existe).
        if (cep !== E.cad.cep.buscado) {
            E.cad.cep = { buscado: '', cidadeID: 0, logradouro: '', bairro: '' };
            E.cad.cepFalhou = false;
            _dicaCep(T.cvCepDica);
            _mostrarEndereco();
        }
        if (cep.length === 8) {
            _buscarCepCadastro();
        }
    });
    _listaDeCidades($('entCidade'), $('entCidadeLista'), c => {
        E.cad.cidadeID = c ? c.id : 0;
        $('entH-entCidade').hidden = true;
        if (c) {
            _mostrarErro('entCidade', '');
        }
    });
    _listaDeOpcoes($('entPais'), $('entPaisLista'), {
        buscar: _buscarPais,
        vazio: T.paisNenhum,
        minimo: 0,
        espera: 0,
        atual: () => E.cad.pais,
        exato: (termo, p) => [_semAcento(p.nome), _semAcento(p.banco)].includes(_semAcento(termo)),
        // Abrir a lista e sair marca o país que já vale: trocar de novo apagaria os erros de CPF e CEP à toa.
        aoEscolher: p => {
            if (p && p.id !== E.cad.pais) {
                _trocarPais(p.id);
            } else if (p) {
                _mostrarErro('entPais', '');
            }
        }
    });
    // Sem escolher na lista, o campo volta ao país que está valendo.
    $('entPais').addEventListener('blur', () => {
        _carregarPaises().then(paises => {
            const atual = paises.find(p => p.id === E.cad.pais);
            if (atual && document.activeElement !== $('entPais')) {
                $('entPais').value = atual.nome;
            }
        }).catch(() => {});
    });
    _validarAoVivo($('entFormNovo'), REGRAS_NOVO);
    // O passo do currículo: as regras do envio (só as das partes que faltam), com o CEP só pela forma (o "não encontrado"
    // vem da busca).
    _validarAoVivo($('entFormCv'), Object.fromEntries(['entCvCep', 'entCvLogradouro', 'entCvBairro', 'entCvCidade', 'entCvCel', 'entCvGrau', 'entCvInst',
        'entCvCurso', 'entCvFormIni', 'entCvFormFim', 'entCvCargo', 'entCvEmpresa', 'entCvExpCidade', 'entCvExpIni', 'entCvExpFim', 'entCvAtividades']
        .map(id => [id, () => (id === 'entCvCep' && E.cv.pais === 'BR' ? (_so($('entCvCep').value).length === 8 ? '' : T.cvErroCep) : _validarCurriculo(_secoesCv())[id] || '')])));
    // O domínio digitado errado aparece logo embaixo do e-mail, sem esperar o "Continuar" (visto, o "Continuar" não o repete).
    let _esperaSugestao = null;
    const _sugestaoAoDigitar = () => {
        const sugestao = _sugerirEmail($('entNovoEmail').value);
        _sugestaoNovo(sugestao);
        if (sugestao) {
            E.cad.sugVisto = true;
        }
    };
    $('entNovoEmail').addEventListener('input', () => {
        clearTimeout(_esperaSugestao);
        _esperaSugestao = setTimeout(_sugestaoAoDigitar, 600);
    });
    $('entNovoEmail').addEventListener('blur', () => {
        clearTimeout(_esperaSugestao);
        _sugestaoAoDigitar();
    });
    _validarAoVivo($('entFormDados'), REGRAS_DADOS, { entNasc: v => v.length === 10, entCpf: v => v.length === 14 });
    $('entCvInput').addEventListener('change', e => {
        const arquivo = e.target.files?.[0];
        e.target.value = '';
        if (arquivo) {
            _enviarArquivoDoCurriculo(arquivo);
        }
    });

    // ----- já entrou -----
    async function _sair(botao) {
        await _comBotao(botao, async () => {
            try {
                await fetch(url('/candidato/sair'), { credentials: 'same-origin', cache: 'no-store' });
            } catch {
                avisarErro(T.erroServidor);
                return;
            }
            avisarLogin('logout');
            esquecerLogado();
            _saindo = true;
            window.location.reload();
        });
    }

    // ----- eventos -----
    cartao.addEventListener('click', e => {
        const t = e.target;
        const alvo = sel => t.closest(sel);
        if (alvo('[data-ent-voltar]')) {
            _voltar();
        } else if (alvo('[data-ent-ir]')) {
            const passo = alvo('[data-ent-ir]').dataset.entIr;
            if (passo === 'entrar' && INICIAL === 'recuperar') {
                $('entUsuario').value = $('entUsuarioRec').value;
            }
            _ir(passo);
        } else if (alvo('[data-ent-google]')) {
            _abrirGoogle();
        } else if (alvo('[data-ent-linkedin]')) {
            _abrirLinkedin();
        } else if (alvo('[data-ent-conta]')) {
            _escolherConta(alvo('[data-ent-conta]'));
        } else if (alvo('[data-ent-trocar]')) {
            // Com várias contas, "Trocar" volta à lista; com uma, ao e-mail ou CPF.
            E.modo = 'entrar';
            const destino = E.pessoas.length ? 'contas' : 'entrar';
            _voltarPara(destino, destino === 'entrar' ? () => $(FORMULARIO.entrar).select() : null);
        } else if (alvo('[data-ent-esqueci]')) {
            E.modo = 'recuperar';
            E.direto = '';
            _comBotao(alvo('[data-ent-esqueci]'), _pedirLink);
        } else if (alvo('[data-ent-criar-senha]')) {
            E.modo = 'recuperar';
            E.direto = '';
            _comBotao(alvo('[data-ent-criar-senha]'), _pedirLink);
        } else if (alvo('[data-ent-direto-quiz]')) {
            E.direto = 'quiz';
            _enviarIdentificador('recuperar', alvo('[data-ent-direto-quiz]'));
        } else if (alvo('[data-ent-sugestao]')) {
            const campo = $(FORMULARIO[E.modo]);
            const sugestao = E.sugestao;
            _voltarPara(E.modo, () => {
                campo.value = sugestao;
                _enviarIdentificador(E.modo, cartao.querySelector(`.ent__passo[data-passo="${E.modo}"] [type="submit"]`));
            });
        } else if (alvo('[data-ent-outro]')) {
            _voltarPara(E.modo, () => {
                const campo = $(FORMULARIO[E.modo]);
                campo.value = '';
                campo.focus();
            });
        } else if (alvo('[data-ent-corrigir]')) {
            _voltarPara(E.modo, () => $(FORMULARIO[E.modo]).select());
        } else if (alvo('[data-ent-reenviar]')) {
            const botao = alvo('[data-ent-reenviar]');
            if (botao.getAttribute('aria-disabled') === 'true') {
                return;
            }
            _comBotao(botao, () => _enviarEmail({ reenvio: true })).then(ok => {
                if (ok) {
                    _esperar(botao, 60, T.reenviar, T.reenviarEm);
                }
            });
        } else if (alvo('[data-ent-sem-email]')) {
            _comBotao(alvo('[data-ent-sem-email]'), _buscarCelular);
        } else if (alvo('[data-ent-enviar-codigo]')) {
            _comBotao(alvo('[data-ent-enviar-codigo]'), _enviarCodigo);
        } else if (alvo('[data-ent-reenviar-codigo]')) {
            // Deu certo: a espera de 30 s (_esperar) trava o botão até acabar; senão, ele volta a valer.
            const botao = alvo('[data-ent-reenviar-codigo]');
            if (ocupado(botao) || botao.getAttribute('aria-disabled') === 'true' || _emAndamento) {
                return;
            }
            ocupar(botao);
            _enviarCodigo().then(ok => {
                ocupar(botao, false);
                if (ok) {
                    botao.setAttribute('aria-disabled', 'true');
                }
            });
        } else if (alvo('[data-ent-quiz]')) {
            _iniciarQuiz(alvo('[data-ent-quiz]'));
        } else if (alvo('[data-ent-sair]')) {
            _sair(alvo('[data-ent-sair]'));
        } else if (alvo('[data-ent-criar]')) {
            E.modo = 'entrar';
            _comecarCadastro();
        } else if (alvo('[data-ent-tipo]')) {
            _escolherTipo(alvo('[data-ent-tipo]').dataset.entTipo);
        } else if (alvo('[data-ent-trocar-tipo]')) {
            E.cad.tipo = _colaborador() ? 'candidato' : 'colaborador';
            ['entCpf', 'entIdExterno'].forEach(id => _mostrarErro(id, ''));
            _mostrarDocumento();
            if (_colaborador()) {
                $('entIdExterno').focus();
            } else if (E.cad.pais === 'BR') {
                $('entCpf').focus();
            }
        } else if (alvo('[data-ent-trocar-cad]')) {
            E.modo = 'entrar';
            _voltarPara('entrar', () => {
                const campo = $(FORMULARIO.entrar);
                campo.value = '';
                campo.focus();
            });
        } else if (alvo('[data-ent-novo-sug]')) {
            if ($('entNovoEmailF').hidden) {
                E.cad.email = E.cad.sugestao;
                _desenharQuemNovo();
            } else {
                $('entNovoEmail').value = E.cad.sugestao;
                $('entNovoEmail').dispatchEvent(new Event('input', { bubbles: true }));
            }
            _sugestaoNovo('');
            $('entNovoNome').focus();
        } else if (alvo('[data-ent-pais]')) {
            _abrirPais();
        } else if (alvo('[data-ent-sem-cep]')) {
            E.cad.semCep = true;
            _mostrarErro('entCep', '');
            _mostrarEndereco();
            $('entCidade').focus();
        } else if (alvo('[data-ent-com-cep]')) {
            E.cad.semCep = false;
            _mostrarErro('entCidade', '');
            _mostrarEndereco();
            $('entCep').focus();
        } else if (alvo('[data-ent-cpf-entrar]')) {
            E.modo = 'entrar';
            $(FORMULARIO.entrar).value = E.cad.cpfConta || '';
            _enviarIdentificador('entrar', alvo('[data-ent-cpf-entrar]'));
        } else if (alvo('[data-ent-cv-arquivo]')) {
            $('entCvInput').click();
        } else if (alvo('[data-ent-cv-mais]')) {
            _abrirExtraCv(alvo('[data-ent-cv-mais]').dataset.entCvMais);
        } else if (alvo('[data-ent-cv-cancelar]')) {
            _mostrarResumoCv({ voltarA: E.cv.extra });
        } else if (alvo('[data-ent-cv-continuar]')) {
            // A roda até a vaga abrir (no celular lento, a troca de página demora).
            ocupar(alvo('[data-ent-cv-continuar]'));
            _voltarParaVaga();
        }
    });

    $('entFormId').addEventListener('submit', e => {
        e.preventDefault();
        _enviarIdentificador('entrar', e.submitter || e.target.querySelector('[type="submit"]'));
    });
    $('entFormRec').addEventListener('submit', e => {
        e.preventDefault();
        E.direto = '';
        _enviarIdentificador('recuperar', e.submitter || e.target.querySelector('[type="submit"]'));
    });
    $('entFormSenha').addEventListener('submit', e => {
        e.preventDefault();
        _entrarComSenha(e.submitter || e.target.querySelector('[type="submit"]'));
    });
    $('entFormNovo').addEventListener('submit', e => {
        e.preventDefault();
        _enviarNovo(e.submitter || e.target.querySelector('[type="submit"]'));
    });
    $('entFormDados').addEventListener('submit', e => {
        e.preventDefault();
        _enviarDados(e.submitter || e.target.querySelector('[type="submit"]'));
    });
    $('entFormCv').addEventListener('submit', e => {
        e.preventDefault();
        _enviarCurriculo(e.submitter || e.target.querySelector('[type="submit"]'));
    });
    $('entFormQuiz')?.addEventListener('submit', e => {
        e.preventDefault();
        _responderQuiz(e.submitter || e.target.querySelector('[type="submit"]'));
    });
    $('entFormQuizContato')?.addEventListener('submit', e => {
        e.preventDefault();
        _enviarContato(e.submitter || e.target.querySelector('[type="submit"]'));
    });
    $('entFormQuizSenha')?.addEventListener('submit', e => {
        e.preventDefault();
        _concluirQuiz(e.submitter || e.target.querySelector('[type="submit"]'));
    });

    // Recrutador: o formulário do v1 (aba "Sou Empresa"), enviado ao Corporate em outra aba.
    $('entFormEmpresa').addEventListener('submit', e => {
        e.preventDefault();
        const email = $('entEmpresaEmail').value.trim();
        const erroEmail = !email ? T.empresaEmail : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ? '' : T.empresaEmailInvalido;
        const erroSenha = $('entEmpresaSenha').value ? '' : T.senhaVazia;
        _mostrarErro('entEmpresaEmail', erroEmail);
        _mostrarErro('entEmpresaSenha', erroSenha);
        if (erroEmail || erroSenha) {
            $(erroEmail ? 'entEmpresaEmail' : 'entEmpresaSenha').focus();
            return;
        }
        e.target.submit();
    });

    ['entUsuario', 'entUsuarioRec'].forEach(id => {
        $(id).addEventListener('blur', e => { e.target.value = _normalizarUsuario(e.target.value); });
        $(id).addEventListener('input', () => _mostrarErro(id, ''));
    });

    // Código: cada caixa aceita o código inteiro (colar ou o preenchimento do celular) e espalha pelas outras.
    _digitos().forEach((d, i) => {
        d.addEventListener('input', () => {
            const v = d.value.replace(/\D/g, '');
            d.value = '';
            if (v) {
                _distribuir(v.length >= _digitos().length ? 0 : i, v.slice(-_digitos().length));
            }
        });
        d.addEventListener('keydown', e => {
            const digitos = _digitos();
            if (e.key === 'Backspace' && !d.value && i > 0) {
                digitos[i - 1].value = '';
                digitos[i - 1].focus();
                e.preventDefault();
            } else if (e.key === 'ArrowLeft' && i > 0) {
                digitos[i - 1].focus();
            } else if (e.key === 'ArrowRight' && i < digitos.length - 1) {
                digitos[i + 1].focus();
            }
        });
    });

    // ----- abertura -----
    if (INICIAL === 'novo' || INICIAL === 'tipo') {
        _comecarCadastro({ empilhar: false });
    }
    history.replaceState({ ..._estadoBase(), entPasso: INICIAL, entDe: null, entN: 0 }, '');
    // Vindo do "Completar e me candidatar" (?curriculo=), o cartão espera saber quem entrou: o HTML é o mesmo para todos e
    // mostraria o "Entrar" a quem já entrou.
    const vagaDoCurriculo = +new URLSearchParams(window.location.search).get('curriculo') || 0;
    if (vagaDoCurriculo) {
        $$('.ent__passo', cartao).forEach(el => { el.hidden = el.dataset.passo !== 'espera'; });
        cartao.setAttribute('aria-busy', 'true');
    } else {
        _mostrar(INICIAL, { focar: false });
    }

    // A vaga do "Candidate-se" no alto (logo, título, empresa e se pede currículo completo; o v1 guarda só o título).
    const p = _pendencia();
    if (p?.titulo && INICIAL === 'entrar') {
        const ctx = $('entCtx');
        ctx.classList.add('ent__ctx--vaga');
        if (p.logo && /^https:\/\//.test(p.logo)) {
            const logo = new Image(36, 36);
            logo.className = 'ent__ctx-logo';
            logo.alt = '';
            // Só troca o ícone depois de carregar: logo que não abre não vira imagem quebrada.
            const icone = ctx.querySelector('.ico');
            logo.addEventListener('load', () => icone?.replaceWith(logo), { once: true });
            logo.src = p.logo;
        }
        const texto = ctx.querySelector('span');
        _comDestaque(texto, T.contexto, p.titulo);
        const linha = [p.conf ? '' : p.empresa, p.local].filter(Boolean).join(' · ');
        if (linha) {
            const sub = document.createElement('small');
            sub.textContent = linha;
            texto.append(sub);
        }
        if (p.cv) {
            const cv = document.createElement('small');
            cv.className = 'ent__ctx-cv';
            cv.textContent = T.pedeCurriculo;
            texto.append(cv);
        }
        ctx.hidden = false;
        $('entT-entrar').textContent = T.entrarOuCriar;
    }

    const q = new URLSearchParams(window.location.search);
    if (q.get('tipo') === 'empresa') {
        _ir('empresa', { substituir: true });
    }
    // "CPF já cadastrado" no cadastro de currículo traz o CPF: vai direto à senha (o v1 preenchia e focava a senha).
    const cpf = q.get('cpf');
    if (cpf && INICIAL === 'entrar') {
        $('entUsuario').value = _normalizarUsuario(cpf);
        _enviarIdentificador('entrar', $('entFormId').querySelector('[type="submit"]'));
    }

    // One Tap nesta tela, e o que veio do One Tap de outra tela (várias contas ou sem cadastro).
    aoRespostaGoogle(credencial => _validarSocial('Google', credencial));
    try {
        const pendente = JSON.parse(sessionStorage.getItem(CHAVE_GOOGLE_PENDENTE));
        sessionStorage.removeItem(CHAVE_GOOGLE_PENDENTE);
        if (pendente?.c && Date.now() - pendente.t < 5 * 60 * 1000) {
            _validarSocial('Google', pendente.c);
        }
    } catch {
        // Sem armazenamento: a tela abre no começo.
    }

    // Quem já entrou vê o atalho para continuar (o HTML é o mesmo para todos); vindo do "Completar e me candidatar" da vaga
    // (?curriculo=), vai direto ao passo do currículo.
    obterUsuario().then(async u => {
        if (u?.logado && vagaDoCurriculo && _passo === INICIAL && await _irCurriculo({ novo: false, substituir: true }).catch(() => false)) {
            return;
        }
        if (vagaDoCurriculo && _passo === INICIAL && cartao.getAttribute('aria-busy') === 'true') {
            _mostrar(INICIAL, { focar: false });
        }
        if (u?.logado && _passo === INICIAL && !E.usuario && !cpf) {
            _comDestaque($('entLogadoTexto'), T.logadoTexto, u.nome || '');
            $('entLogadoContinuar').href = _returnUrl() || url('/candidato/painel');
            _ir('logado', { substituir: true });
        }
    });
}

if ($('entSaiu')) {
    _iniciarSair();
} else if ($('entFormNova')) {
    _iniciarNovaSenha();
} else if ($('entReativar')) {
    _iniciarReativar();
} else if ($('entFormTermos')) {
    _iniciarTermos();
} else if ($('entFormMatricula')) {
    _iniciarMatricula();
} else if ($('entFormConcluir')) {
    _iniciarConcluir();
} else if ($('entFormContato')) {
    _iniciarContato();
} else if ($('entPendente')) {
    _iniciarPendente();
} else if ($('tstArea')) {
    _iniciarTeste();
} else if ($('entFormPerfil')) {
    _iniciarPerfil();
} else if ($('entFormDescadastro') || $('entFormEncontrado')) {
    // Descadastro de e-mail e confirmação do cadastro encontrado: o POST é do próprio formulário (funciona sem JS); a roda fica
    // até a página trocar, e o 2º clique não envia.
    ($('entFormDescadastro') || $('entFormEncontrado')).addEventListener('submit', e => {
        const botao = e.currentTarget.querySelector('[type=submit]');
        if (ocupado(botao)) {
            e.preventDefault();
            return;
        }
        ocupar(botao);
    });
} else if ($('entOpcoes')) {
    _iniciarEntrar();
    iniciarMedicaoPagina('login');
}
